(function () {
  "use strict";

  if (window.TwoNuCompare && window.TwoNuCompare.__version === 1) return;

  var VERSION = 1;
  var STORAGE_KEY = "twoNu.compare.v1";
  var MAX_ITEMS = 3;
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var PRODUCT_CACHE_MS = 60 * 1000;
  var AXES = ["running", "trail", "water", "cycling", "driving", "golf", "everyday", "alpine"];
  var HEAD_SHAPE_ORDER = ["standard_small", "standard", "standard_wide", "wide_fit"];
  var MODEL_FIT_LABELS = {
    fancy: "Normal",
    halo: "Normal - Smaller",
    cogs: "Normal - Larger",
    ovo: "Larger",
    zealot: "Normal",
    venti_air: "Flexible"
  };
  var SERIES = [
    { color: "#0BF477", shadow: "rgba(11, 244, 119, .2)" },
    { color: "#483CFF", shadow: "rgba(72, 60, 255, .2)" },
    { color: "#FF61EF", shadow: "rgba(255, 97, 239, .2)" }
  ];
  var FEATURE_ORDER = ["uv400", "polarized", "hexachroma", "metonic", "flexfoam", "float_max", "prescription"];

  var DEFAULT_LABELS = {
    compare: "Compare",
    open: "Open comparison",
    openCount: "Open comparison, [count] items",
    add: "Add to comparison",
    addedView: "Added · View comparison",
    dialogTitle: "Compare your shortlist",
    count: "[count] of 3",
    clearAll: "Clear all",
    close: "Close comparison",
    emptyTitle: "No glasses saved yet",
    emptyCopy: "Choose an exact colour and lens, then add it to comparison.",
    oneMore: "Add one more pair to start comparing.",
    fullTitle: "Your comparison is full",
    fullCopy: "Choose one saved pair to replace with your new selection.",
    replaceThis: "Replace this pair",
    cancel: "Cancel",
    frameFeel: "Frame feel",
    coverage: "Coverage",
    bestFor: "Best starting point",
    fit: "Head fit",
    included: "Included",
    notIncluded: "Not included",
    featureDialogClose: "Close",
    fitDialogTitle: "Head fit guide",
    fitDialogClose: "Close",
    frameColor: "Frame colour",
    lensColor: "Lens colour",
    lensFamily: "Lens family",
    frameMaterial: "Frame material",
    price: "Price",
    availability: "Availability",
    available: "Available",
    soldOut: "Sold out",
    refreshing: "Refreshing price and availability…",
    refreshFailed: "Unable to refresh",
    unavailable: "Unavailable in this market",
    notRated: "Lens activity profile not available",
    addToCart: "Add to cart",
    addingToCart: "Adding…",
    addedToCartShort: "Added",
    orderNow: "Order Now",
    aiTryOn: "AI Try On",
    viewVariant: "View Variants",
    remove: "Remove",
    previous: "Previous pair",
    next: "Next pair",
    addedToComparison: "Added to comparison · [count] of 3",
    removedFromComparison: "Removed from comparison",
    cleared: "Comparison cleared",
    replaced: "Comparison updated",
    savedVisitOnly: "Comparison is saved for this visit only.",
    cartAdded: "Exact variant added to cart",
    cartError: "This variant could not be added to cart",
    refreshComplete: "Price and availability updated",
    productImage: "Product image",
    view: "View",
    undo: "Undo"
  };

  function nowIso() {
    return new Date().toISOString();
  }

  function clone(value) {
    if (typeof structuredClone === "function") {
      try {
        return structuredClone(value);
      } catch (error) {
        // JSON fallback below.
      }
    }
    return JSON.parse(JSON.stringify(value));
  }

  function isObject(value) {
    return Boolean(value) && typeof value === "object" && !Array.isArray(value);
  }

  function safeParse(value, fallback) {
    if (typeof value !== "string" || !value.trim()) return fallback;
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function cleanString(value, maxLength) {
    if (value === null || value === undefined) return "";
    var next = String(value).trim();
    return next.slice(0, maxLength || 500);
  }

  function cleanId(value) {
    var id = cleanString(value, 40);
    return /^\d+$/.test(id) ? id : "";
  }

  function numberOrNull(value) {
    if (value === "" || value === null || value === undefined) return null;
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function booleanOrNull(value) {
    if (value === true || value === false) return value;
    if (value === "true" || value === 1 || value === "1") return true;
    if (value === "false" || value === 0 || value === "0") return false;
    return null;
  }

  function firstDefined() {
    for (var index = 0; index < arguments.length; index += 1) {
      if (arguments[index] !== undefined && arguments[index] !== null && arguments[index] !== "") {
        return arguments[index];
      }
    }
    return null;
  }

  function slug(value) {
    return cleanString(value, 120)
      .toLowerCase()
      .replace(/™/g, "")
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
  }

  function humanize(value) {
    var text = cleanString(value, 120).replace(/_/g, " ").replace(/\s+/g, " ").trim();
    return text ? text.replace(/\b\w/g, function (letter) { return letter.toUpperCase(); }) : "";
  }

  function template(value, replacements) {
    var output = cleanString(value, 1000);
    Object.keys(replacements || {}).forEach(function (key) {
      output = output.split("[" + key + "]").join(String(replacements[key]));
    });
    return output;
  }

  function safeUrl(value) {
    var raw = cleanString(value, 1200);
    if (!raw) return "";
    try {
      var parsed = new URL(raw, window.location.origin);
      if (parsed.origin !== window.location.origin && parsed.protocol !== "https:") return "";
      if (parsed.origin === window.location.origin) {
        return parsed.pathname + parsed.search + parsed.hash;
      }
      return parsed.href;
    } catch (error) {
      return "";
    }
  }

  function safeImageUrl(value) {
    var raw = cleanString(value, 1500);
    if (!raw) return "";
    if (raw.indexOf("//") === 0) return window.location.protocol + raw;
    try {
      var parsed = new URL(raw, window.location.origin);
      if (parsed.protocol !== "https:" && parsed.origin !== window.location.origin) return "";
      return parsed.href;
    } catch (error) {
      return "";
    }
  }

  function handleFromUrl(value) {
    var url = safeUrl(value);
    var match = url.match(/\/products\/([^/?#]+)/i);
    return match ? cleanString(match[1], 160).toLowerCase() : "";
  }

  function cleanHandle(value) {
    var handle = cleanString(value, 160).toLowerCase();
    return /^[a-z0-9][a-z0-9-]*$/.test(handle) ? handle : "";
  }

  function withVariant(url, variantId) {
    var safe = safeUrl(url);
    if (!safe) return "";
    try {
      var parsed = new URL(safe, window.location.origin);
      parsed.searchParams.set("variant", variantId);
      return parsed.origin === window.location.origin
        ? parsed.pathname + parsed.search + parsed.hash
        : parsed.href;
    } catch (error) {
      return safe;
    }
  }

  function modelKeyFrom(raw, handle, title) {
    var direct = slug(firstDefined(
      raw && raw.modelKey,
      raw && raw.model,
      raw && raw.selection && raw.selection.modelKey,
      raw && raw.profile && raw.profile.modelKey
    ));
    if (direct) {
      if (direct === "venti" || direct === "venti_air_sunglasses") return "venti_air";
      return direct;
    }
    var haystack = (cleanString(handle) + " " + cleanString(title)).toLowerCase();
    if (haystack.indexOf("venti") !== -1) return "venti_air";
    return ["fancy", "halo", "cogs", "ovo", "zealot"].find(function (key) {
      return haystack.indexOf(key) !== -1;
    }) || "";
  }

  function normalizeScores(raw) {
    var source = isObject(raw) ? raw : {};
    var scores = {};
    AXES.forEach(function (axis) {
      var value = numberOrNull(source[axis]);
      scores[axis] = value !== null && value >= 0 && value <= 5 ? value : null;
    });
    return scores;
  }

  function normalizeFeatures(raw) {
    var source = isObject(raw) ? raw : {};
    function read() {
      for (var index = 0; index < arguments.length; index += 1) {
        var key = arguments[index];
        if (Object.prototype.hasOwnProperty.call(source, key)) return booleanOrNull(source[key]);
      }
      return null;
    }
    return {
      uv400: read("uv400"),
      polarized: read("polarized"),
      hexachroma: read("hexachroma", "hex"),
      metonic: read("metonic", "hasMetonic", "has_metonic"),
      flexfoam: read("flexfoam", "hasFlexfoam", "has_flexfoam"),
      floatMax: read("floatMax", "float_max", "hasFloatMax", "has_float_max"),
      prescription: read("prescription", "isPrescription", "is_prescription")
    };
  }

  function normalizeLensSliderImage(raw, title) {
    var source = isObject(raw) ? raw : {};
    var url = safeImageUrl(firstDefined(source.url, source.src, raw));
    return {
      url: url,
      srcset: cleanString(firstDefined(source.srcset, source.srcSet), 4000),
      alt: cleanString(firstDefined(source.alt, title), 300)
    };
  }

  function normalizeLensSlider(raw, title) {
    if (!isObject(raw)) return null;
    var source = isObject(raw.lensSlider)
      ? raw.lensSlider
      : (isObject(raw.lens_slider) ? raw.lens_slider : raw);
    var scenesRaw = source.scenes;
    var sceneEntries = Array.isArray(scenesRaw)
      ? scenesRaw.map(function (scene, index) {
        return [firstDefined(scene && scene.key, scene && scene.id, "scene-" + (index + 1)), scene];
      })
      : (isObject(scenesRaw) ? Object.entries(scenesRaw) : []);
    var scenes = sceneEntries.map(function (entry, index) {
      var scene = isObject(entry[1]) ? entry[1] : {};
      var key = slug(firstDefined(scene.key, scene.id, entry[0], "scene-" + (index + 1)));
      var before = normalizeLensSliderImage(scene.before, title);
      var after = normalizeLensSliderImage(scene.after, title);
      if (!key || !before.url || !after.url) return null;
      var thumbnail = isObject(scene.thumbnail) ? scene.thumbnail : {};
      return {
        key: key,
        label: cleanString(firstDefined(scene.label, scene.title, humanize(key)), 80),
        thumbnailUrl: safeImageUrl(firstDefined(
          thumbnail.url,
          thumbnail.src,
          scene.thumbnailUrl,
          scene.thumbnail_url,
          after.url
        )),
        before: before,
        after: after,
        beforeLabel: cleanString(firstDefined(
          scene.beforeLabel,
          scene.before_label,
          "Naked Eye"
        ), 80),
        afterLabel: cleanString(firstDefined(
          scene.afterLabel,
          scene.after_label,
          source.afterLabel,
          source.after_label
        ), 80)
      };
    }).filter(Boolean).slice(0, 6);
    if (!scenes.length) return null;
    var defaultScene = slug(firstDefined(
      source.defaultScene,
      source.default_scene,
      scenes[0].key
    ));
    if (!scenes.some(function (scene) { return scene.key === defaultScene; })) {
      defaultScene = scenes[0].key;
    }
    return {
      defaultScene: defaultScene,
      scenes: scenes
    };
  }

  function normalizeImage(raw, title) {
    var source = isObject(raw) ? raw : {};
    var url = safeImageUrl(firstDefined(source.url, source.src, raw));
    return {
      url: url,
      thumbnailUrl: safeImageUrl(firstDefined(source.thumbnailUrl, source.thumbnail_url, source.preview, url)),
      srcset: cleanString(firstDefined(source.srcset, source.srcSet), 4000),
      alt: cleanString(firstDefined(source.alt, title), 300),
      type: slug(firstDefined(source.type, source.mediaType, "image")) || "image",
      lensSlider: normalizeLensSlider(firstDefined(source.lensSlider, source.lens_slider), title)
    };
  }

  function normalizeGallery(raw, primaryImage, title) {
    var source = Array.isArray(raw) ? raw : [];
    var seen = new Set();
    return [primaryImage].concat(source).map(function (entry) {
      return normalizeImage(entry, title);
    }).filter(function (entry) {
      if (!entry.url || seen.has(entry.url)) return false;
      seen.add(entry.url);
      return true;
    }).slice(0, 12);
  }

  function normalizeItem(raw, fallbackId) {
    if (!isObject(raw)) return null;
    var variantId = cleanId(firstDefined(raw.variantId, raw.variant_id, raw.id, fallbackId));
    if (!variantId) return null;

    var canonicalUrl = safeUrl(firstDefined(raw.canonicalUrl, raw.productUrl, raw.url));
    var productHandle = cleanHandle(firstDefined(
      raw.productHandle,
      raw.product_handle,
      raw.handle,
      handleFromUrl(canonicalUrl)
    ));
    var productTitle = cleanString(firstDefined(raw.productTitle, raw.product_title, raw.title), 260);
    var variantTitle = cleanString(firstDefined(raw.variantTitle, raw.variant_title, raw.optionTitle), 300);
    var selectionRaw = isObject(raw.selection) ? raw.selection : {};
    var profileRaw = isObject(raw.profile) ? raw.profile : {};
    var commerceRaw = isObject(raw.commerce) ? raw.commerce : {};
    var modelKey = modelKeyFrom(raw, productHandle, productTitle);

    var frameColorLabel = cleanString(firstDefined(
      selectionRaw.frameColorLabel,
      raw.frameColorLabel,
      raw.frameColorTitle,
      raw.frame_color_title
    ), 160);
    var lensColorLabel = cleanString(firstDefined(
      selectionRaw.lensColorLabel,
      raw.lensColorLabel,
      raw.lensesColorTitle,
      raw.lensColorTitle,
      raw.lenses_color_title
    ), 160);
    var lensFamilyKey = slug(firstDefined(
      selectionRaw.lensFamilyKey,
      raw.lensFamilyKey,
      raw.lens_family,
      Array.isArray(raw.families) ? raw.families[0] : raw.family
    ));
    var frameMaterialKey = slug(firstDefined(
      selectionRaw.frameMaterialKey,
      raw.frameMaterialKey,
      raw.frameMaterialLabel,
      raw.frame_material
    ));
    var frameMaterialLabel = cleanString(firstDefined(
      selectionRaw.frameMaterialLabel,
      raw.frameMaterialLabel,
      raw.frame_material_label,
      humanize(frameMaterialKey)
    ), 160);
    var lensFamilyLabel = cleanString(firstDefined(
      selectionRaw.lensFamilyLabel,
      raw.lensFamilyLabel,
      raw.lens_family_label
    ), 160);

    var featureRaw = isObject(profileRaw.features)
      ? profileRaw.features
      : (isObject(raw.features) ? raw.features : {});
    var activityRaw = firstDefined(
      profileRaw.activityScores,
      raw.activityScores,
      raw.activity_scores
    );
    if (typeof activityRaw === "string") activityRaw = safeParse(activityRaw, {});

    var aiTryOnRaw = isObject(profileRaw.aiTryOn)
      ? profileRaw.aiTryOn
      : (isObject(raw.aiTryOn) ? raw.aiTryOn : {});
    var physicalTryOnRaw = isObject(profileRaw.physicalTryOn)
      ? profileRaw.physicalTryOn
      : (isObject(raw.physicalTryOn) ? raw.physicalTryOn : {});
    var prescriptionRaw = isObject(profileRaw.prescription)
      ? profileRaw.prescription
      : (isObject(raw.prescription) ? raw.prescription : {});

    canonicalUrl = withVariant(
      canonicalUrl || (productHandle ? "/products/" + productHandle : ""),
      variantId
    );

    var primaryImage = normalizeImage(firstDefined(
      raw.image,
      raw.featuredImage,
      raw.featured_image,
      raw.imageUrl ? { url: raw.imageUrl, alt: raw.imageAlt } : null
    ), productTitle);
    var galleryRaw = firstDefined(
      raw.gallery,
      raw.media,
      raw.pictureInPictureImages,
      raw.picture_in_picture_images,
      raw.pipImages,
      raw.pip_images
    );

    return {
      variantId: variantId,
      productId: cleanId(firstDefined(raw.productId, raw.product_id)),
      productHandle: productHandle,
      canonicalUrl: canonicalUrl,
      productTitle: productTitle,
      variantTitle: variantTitle,
      // CODEX_V1423_COMPARE_SKU_RADAR_CLEANUP_20260713: retain the exact Shopify variant SKU separately from customer-facing option labels.
      sku: cleanString(firstDefined(
        raw.shopifySku,
        raw.shopify_sku,
        raw.sku,
        raw.variantSku,
        raw.variant_sku,
        selectionRaw.sku
      ), 160),
      image: primaryImage,
      gallery: normalizeGallery(galleryRaw, primaryImage, productTitle),
      selection: {
        modelKey: modelKey,
        frameColorKey: slug(firstDefined(selectionRaw.frameColorKey, raw.frameColor, raw.frame_color)),
        frameColorLabel: frameColorLabel,
        lensColorKey: slug(firstDefined(selectionRaw.lensColorKey, raw.lensesColor, raw.lensColor, raw.lenses_color)),
        lensColorLabel: lensColorLabel,
        lensFamilyKey: lensFamilyKey,
        lensFamilyLabel: lensFamilyLabel,
        frameMaterialKey: frameMaterialKey,
        frameMaterialLabel: frameMaterialLabel
      },
      profile: {
        revision: cleanString(firstDefined(profileRaw.revision, raw.profileRevision, "comparison-profile-1"), 120),
        modelKey: modelKey,
        shapeKey: slug(firstDefined(profileRaw.shapeKey, raw.shapeKey)),
        shapeLabel: cleanString(firstDefined(profileRaw.shapeLabel, raw.shapeLabel), 260),
        fitKey: slug(firstDefined(profileRaw.fitKey, raw.fitKey, raw.fitLabel)),
        fitLabel: cleanString(firstDefined(profileRaw.fitLabel, raw.fitLabel), 260),
        coverageKey: slug(firstDefined(profileRaw.coverageKey, raw.coverageKey)),
        coverageLabel: cleanString(firstDefined(profileRaw.coverageLabel, raw.coverageLabel), 500),
        frameFeel: cleanString(firstDefined(profileRaw.frameFeel, raw.frameFeel), 600),
        bestFor: cleanString(firstDefined(profileRaw.bestFor, raw.bestFor), 600),
        measurements: isObject(profileRaw.measurements) ? clone(profileRaw.measurements) : {},
        features: normalizeFeatures(featureRaw),
        activityScores: normalizeScores(activityRaw),
        aiTryOn: {
          available: booleanOrNull(firstDefined(
            aiTryOnRaw.available,
            typeof profileRaw.aiTryOn === "boolean" ? profileRaw.aiTryOn : null,
            typeof raw.aiTryOn === "boolean" ? raw.aiTryOn : null,
            raw.aiTryOnAvailable
          )),
          url: safeUrl(firstDefined(aiTryOnRaw.url, raw.aiTryOnUrl))
        },
        physicalTryOn: {
          available: booleanOrNull(firstDefined(
            physicalTryOnRaw.available,
            raw.physicalTryOnAvailable,
            firstDefined(physicalTryOnRaw.url, raw.physicalTryOnUrl) ? true : null
          )),
          url: safeUrl(firstDefined(physicalTryOnRaw.url, raw.physicalTryOnUrl))
        },
        prescription: {
          isPrescription: booleanOrNull(firstDefined(
            prescriptionRaw.isPrescription,
            raw.isPrescription,
            lensFamilyKey === "pre" || lensFamilyKey === "hex_pre" ? true : null
          )),
          limitLabel: cleanString(firstDefined(prescriptionRaw.limitLabel, raw.prescriptionLimitLabel), 400)
        }
      },
      commerce: {
        price: numberOrNull(firstDefined(commerceRaw.price, raw.price)),
        compareAtPrice: numberOrNull(firstDefined(
          commerceRaw.compareAtPrice,
          commerceRaw.compare_at_price,
          raw.compareAtPrice,
          raw.compare_at_price
        )),
        currency: cleanString(firstDefined(commerceRaw.currency, raw.currency), 8).toUpperCase(),
        available: booleanOrNull(firstDefined(commerceRaw.available, raw.available)),
        capturedAt: cleanString(firstDefined(commerceRaw.capturedAt, raw.capturedAt), 40),
        marketSignature: cleanString(firstDefined(commerceRaw.marketSignature, raw.marketSignature), 240),
        source: cleanString(firstDefined(commerceRaw.source, raw.source), 40)
      },
      savedAt: cleanString(firstDefined(raw.savedAt, nowIso()), 40)
    };
  }

  function mergeValue(previous, next) {
    if (next === null || next === undefined || next === "") return clone(previous);
    if (isObject(previous) && isObject(next)) {
      var output = clone(previous);
      Object.keys(next).forEach(function (key) {
        output[key] = mergeValue(previous[key], next[key]);
      });
      return output;
    }
    return clone(next);
  }

  function mergeItem(previous, next) {
    if (!previous) return clone(next);
    return normalizeItem(mergeValue(previous, next), next.variantId) || clone(next);
  }

  function stateWithItems(items, previousState, touch) {
    var timestamp = Date.now();
    var previousExpiry = previousState && Date.parse(previousState.expiresAt);
    return {
      version: VERSION,
      updatedAt: new Date(timestamp).toISOString(),
      expiresAt: new Date(touch || !Number.isFinite(previousExpiry)
        ? timestamp + TTL_MS
        : previousExpiry).toISOString(),
      items: items.slice(0, MAX_ITEMS)
    };
  }

  function validateState(raw) {
    if (!isObject(raw) || raw.version !== VERSION || !Array.isArray(raw.items)) return null;
    var expiry = Date.parse(raw.expiresAt);
    if (!Number.isFinite(expiry) || expiry <= Date.now()) return null;
    var seen = new Set();
    var items = [];
    raw.items.forEach(function (rawItem) {
      var item = normalizeItem(rawItem, rawItem && rawItem.variantId);
      if (!item || seen.has(item.variantId) || items.length >= MAX_ITEMS) return;
      seen.add(item.variantId);
      items.push(item);
    });
    return {
      version: VERSION,
      updatedAt: cleanString(raw.updatedAt, 40) || nowIso(),
      expiresAt: new Date(expiry).toISOString(),
      items: items
    };
  }

  function ComparisonStore(onFallback) {
    this.onFallback = onFallback;
    this.persistent = true;
    this.fallbackAnnounced = false;
    this.memoryState = stateWithItems([], null, true);
    this.state = this.read();
  }

  ComparisonStore.prototype.useFallback = function () {
    this.persistent = false;
    if (!this.fallbackAnnounced) {
      this.fallbackAnnounced = true;
      if (typeof this.onFallback === "function") this.onFallback();
    }
  };

  ComparisonStore.prototype.read = function () {
    if (!this.persistent) return clone(this.memoryState);
    try {
      var value = window.localStorage.getItem(STORAGE_KEY);
      if (!value) return stateWithItems([], null, true);
      var validated = validateState(JSON.parse(value));
      if (!validated) {
        window.localStorage.removeItem(STORAGE_KEY);
        return stateWithItems([], null, true);
      }
      this.memoryState = clone(validated);
      return validated;
    } catch (error) {
      this.useFallback();
      return clone(this.memoryState);
    }
  };

  ComparisonStore.prototype.save = function (items, options) {
    var next = stateWithItems(items, this.state, !options || options.touch !== false);
    this.state = next;
    this.memoryState = clone(next);
    if (!this.persistent) return clone(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (error) {
      this.useFallback();
    }
    return clone(next);
  };

  ComparisonStore.prototype.readExternal = function () {
    if (!this.persistent) return null;
    try {
      var value = window.localStorage.getItem(STORAGE_KEY);
      if (!value) return stateWithItems([], null, true);
      var validated = validateState(JSON.parse(value));
      if (!validated) return stateWithItems([], null, true);
      this.state = validated;
      this.memoryState = clone(validated);
      return clone(validated);
    } catch (error) {
      return null;
    }
  };

  function createElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined && text !== null) element.textContent = String(text);
    return element;
  }

  function appendTextRow(parent, className, label, value, fieldKey, same) {
    var row = createElement("div", className);
    row.dataset.twoNuCompareField = fieldKey;
    row.dataset.twoNuCompareSame = same ? "true" : "false";
    var term = createElement("dt", className + "-label", label);
    var description = createElement("dd", className + "-value", value || "—");
    row.append(term, description);
    parent.appendChild(row);
    return row;
  }

  function ComparisonController() {
    var controller = this;
    this.__version = VERSION;
    this.catalog = new Map();
    this.catalogScripts = new WeakSet();
    this.addObservers = new WeakMap();
    this.productCache = new Map();
    this.galleryRequests = new Map();
    this.pendingCartIds = new Set();
    this.runtimeStatus = new Map();
    this.pendingReplacement = null;
    this.activeIndex = 0;
    this.lastFocus = null;
    this.lastUndoItems = null;
    this.toastTimer = 0;
    this.scrollFrame = 0;
    this.scrollTargetIndex = null;
    this.scrollTargetTimer = 0;
    this.resizeFrame = 0;
    this.refreshController = null;
    this.scrollLock = null;
    this.boundDialog = null;
    this.boundCards = null;
    this.memoryFallbackPending = false;
    this.suppressFocusRestore = false;
    this.popupMotionClosing = false;
    this.infoPopupTrigger = null;
    this.aiTryOnTrigger = null;
    this.aiTryOnLayer = null;
    this.aiTryOnRootTimer = 0;
    this.boundInfoHost = null;
    this.boundAiHost = null;
    this.nestedEscapeUntil = 0;
    this.store = new ComparisonStore(function () {
      controller.memoryFallbackPending = true;
    });
    this.items = clone(this.store.state.items);
    this.i18n = {
      labels: clone(DEFAULT_LABELS),
      axes: {},
      families: {},
      features: {},
      featureInfo: {},
      fitOptions: {},
      fitInfo: {},
      models: {}
    };
    this.root = null;
    this.elements = {};
    this.install();
  }

  ComparisonController.prototype.label = function (key, fallback, replacements) {
    var value = this.i18n && this.i18n.labels ? this.i18n.labels[key] : "";
    return template(value || fallback || DEFAULT_LABELS[key] || key, replacements || {});
  };

  ComparisonController.prototype.axisLabel = function (axis) {
    return cleanString(this.i18n.axes && this.i18n.axes[axis], 100) || humanize(axis);
  };

  ComparisonController.prototype.familyLabel = function (key) {
    return cleanString(this.i18n.families && this.i18n.families[key], 120) || humanize(key);
  };

  ComparisonController.prototype.featureLabel = function (key) {
    return cleanString(this.i18n.features && this.i18n.features[key], 160) || humanize(key);
  };

  ComparisonController.prototype.featureInfo = function (key) {
    return cleanString(this.i18n.featureInfo && this.i18n.featureInfo[key], 8000);
  };

  ComparisonController.prototype.fitInfo = function (key) {
    var info = this.i18n.fitInfo && this.i18n.fitInfo[key];
    return isObject(info) ? info : null;
  };

  ComparisonController.prototype.install = function () {
    var controller = this;
    this.bindRoot();
    this.registerCatalogs(document);
    this.observeAddButtons(document);
    this.render();

    document.addEventListener("click", function (event) {
      controller.guardNonModalClick(event);
    }, true);
    document.addEventListener("click", function (event) {
      controller.handleClick(event);
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && (controller.aiTryOnLayer || controller.infoPopupIsOpen())) {
        controller.nestedEscapeUntil = Date.now() + 160;
      }
      controller.handleKeydown(event);
    }, true);
    document.addEventListener("two-nu:variant-change", function (event) {
      controller.handleVariantChange(event);
    });
    document.addEventListener("shopify:section:load", function (event) {
      controller.bindRoot();
      controller.registerCatalogs(event.target || document);
      controller.observeAddButtons(event.target || document);
      controller.render();
    });
    window.addEventListener("storage", function (event) {
      controller.handleStorage(event);
    });
    window.addEventListener("resize", function () {
      window.cancelAnimationFrame(controller.resizeFrame);
      controller.resizeFrame = window.requestAnimationFrame(function () {
        if (controller.dialogIsOpen()) controller.drawRadars();
      });
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (controller.dialogIsOpen()) controller.drawRadars();
      });
    }
  };

  ComparisonController.prototype.ensureAiTryOnMaster = function () {
    var existing = document.getElementById("ai-tryon-btn");
    if (existing) return existing;
    var appAvailable = document.getElementById("ai-tryon-react-root") ||
      document.querySelector("script[src*='2nu-ai-tryon-app']");
    if (!appAvailable) return null;
    var button = createElement("button", "two-nu-compare__ai-master");
    button.id = "ai-tryon-btn";
    button.type = "button";
    button.tabIndex = -1;
    button.setAttribute("aria-hidden", "true");
    button.style.cssText = "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;";
    (document.body || document.documentElement).appendChild(button);
    return button;
  };

  ComparisonController.prototype.bindRoot = function () {
    var root = document.querySelector("[data-two-nu-compare-root]");
    if (!root) return;
    this.root = root;
    var i18nScript = root.querySelector("[data-two-nu-compare-i18n]");
    var parsed = i18nScript ? safeParse(i18nScript.textContent, {}) : {};
    this.i18n = {
      labels: mergeValue(DEFAULT_LABELS, isObject(parsed.labels) ? parsed.labels : {}),
      axes: isObject(parsed.axes) ? parsed.axes : {},
      families: isObject(parsed.families) ? parsed.families : {},
      features: isObject(parsed.features) ? parsed.features : {},
      featureInfo: isObject(parsed.featureInfo) ? parsed.featureInfo : {},
      fitOptions: isObject(parsed.fitOptions) ? parsed.fitOptions : {},
      fitInfo: isObject(parsed.fitInfo) ? parsed.fitInfo : {},
      models: isObject(parsed.models) ? parsed.models : {}
    };
    this.elements = {
      dialog: root.querySelector("[data-two-nu-compare-dialog]"),
      heading: root.querySelector("[data-two-nu-compare-heading]"),
      dialogCount: root.querySelector("[data-two-nu-compare-dialog-count]"),
      clear: root.querySelector("[data-two-nu-compare-clear]"),
      empty: root.querySelector("[data-two-nu-compare-empty]"),
      main: root.querySelector("[data-two-nu-compare-main]"),
      replacement: root.querySelector("[data-two-nu-compare-replacement]"),
      cards: root.querySelector("[data-two-nu-compare-cards]"),
      previous: root.querySelector("[data-two-nu-compare-prev], [data-two-nu-compare-previous]"),
      next: root.querySelector("[data-two-nu-compare-next]"),
      legend: root.querySelector("[data-two-nu-compare-legend]"),
      canvas: root.querySelector("[data-two-nu-compare-canvas]"),
      mobileDetails: root.querySelector("[data-two-nu-compare-mobile-details]"),
      notRated: root.querySelector("[data-two-nu-compare-not-rated]"),
      toast: root.querySelector("[data-two-nu-compare-toast]"),
      toastMessage: root.querySelector("[data-two-nu-compare-toast-message]"),
      toastView: root.querySelector("[data-two-nu-compare-toast-view]"),
      toastUndo: root.querySelector("[data-two-nu-compare-toast-undo]"),
      live: root.querySelector("[data-two-nu-compare-live]"),
      infoHost: root.querySelector("[data-two-nu-compare-info-host]"),
      infoTitle: root.querySelector("[data-two-nu-compare-info-title]"),
      infoContent: root.querySelector("[data-two-nu-compare-info-content]"),
      aiHost: root.querySelector("[data-two-nu-compare-ai-host]")
    };
    if (this.elements.heading) this.elements.heading.textContent = this.label("dialogTitle");
    if (this.elements.heading && this.elements.heading.parentElement) {
      this.elements.heading.parentElement.classList.add("two-nu-compare__heading");
    }
    if (this.elements.cards) this.elements.cards.classList.add("two-nu-compare__track");
    if (this.elements.legend) this.elements.legend.classList.add("two-nu-compare__radar-legend");
    if (this.elements.canvas) this.elements.canvas.classList.add("two-nu-compare__radar-canvas");
    if (this.elements.toastView) this.elements.toastView.classList.add("two-nu-compare__toast-action");
    if (this.elements.toastUndo) this.elements.toastUndo.classList.add("two-nu-compare__toast-action");

    if (this.elements.dialog && this.boundDialog !== this.elements.dialog) {
      this.boundDialog = this.elements.dialog;
      this.elements.dialog.addEventListener("cancel", this.onDialogCancel.bind(this));
      this.elements.dialog.addEventListener("close", this.onDialogClosed.bind(this));
      this.elements.dialog.addEventListener("click", this.onDialogBackdrop.bind(this));
    }
    if (this.elements.cards && this.boundCards !== this.elements.cards) {
      this.boundCards = this.elements.cards;
      this.elements.cards.addEventListener("scroll", this.onCardsScroll.bind(this), { passive: true });
      this.elements.cards.addEventListener("scrollend", this.onCardsScrollEnd.bind(this), { passive: true });
      this.elements.cards.addEventListener("pointerdown", this.onCardsPointerDown.bind(this), { passive: true });
    }
    if (this.elements.infoHost && this.boundInfoHost !== this.elements.infoHost) {
      this.boundInfoHost = this.elements.infoHost;
      this.elements.infoHost.addEventListener("cancel", function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.nestedEscapeUntil = Date.now() + 160;
        this.closeInfoPopup();
      }.bind(this));
      this.elements.infoHost.addEventListener("close", this.onInfoPopupClosed.bind(this));
      this.elements.infoHost.addEventListener("click", this.onInfoPopupBackdrop.bind(this));
    }
    if (this.elements.aiHost && this.boundAiHost !== this.elements.aiHost) {
      this.boundAiHost = this.elements.aiHost;
      this.elements.aiHost.addEventListener("cancel", function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.nestedEscapeUntil = Date.now() + 160;
      }.bind(this));
      this.elements.aiHost.addEventListener("close", function () {
        if (this.aiTryOnLayer && this.aiTryOnLayer.host === this.elements.aiHost) {
          this.cleanupAiTryOnLayer(true);
        }
      }.bind(this));
    }
    if (this.memoryFallbackPending) {
      this.memoryFallbackPending = false;
      this.announce(this.label("savedVisitOnly"));
    }
  };

  ComparisonController.prototype.infoPopupIsOpen = function () {
    return Boolean(this.elements.infoHost && this.elements.infoHost.hasAttribute("open"));
  };

  ComparisonController.prototype.openInfoPopup = function (title, html, trigger) {
    this.bindRoot();
    var host = this.elements.infoHost;
    var content = this.elements.infoContent;
    if (!host || !content || !cleanString(html, 20000)) return false;
    this.infoPopupTrigger = trigger instanceof HTMLElement ? trigger : document.activeElement;
    if (this.elements.infoTitle) this.elements.infoTitle.textContent = cleanString(title, 240);
    content.innerHTML = String(html);
    if (!host.hasAttribute("open")) {
      if (typeof host.showModal === "function") host.showModal();
      else {
        host.setAttribute("open", "");
        host.setAttribute("aria-modal", "true");
      }
    }
    var close = host.querySelector("[data-two-nu-compare-info-close]");
    if (close) close.focus({ preventScroll: true });
    return true;
  };

  ComparisonController.prototype.closeInfoPopup = function () {
    var host = this.elements.infoHost;
    if (!host || !host.hasAttribute("open")) return;
    if (typeof host.close === "function") host.close();
    else {
      host.removeAttribute("open");
      this.onInfoPopupClosed();
    }
  };

  ComparisonController.prototype.onInfoPopupClosed = function () {
    if (this.elements.infoContent) this.elements.infoContent.replaceChildren();
    var trigger = this.infoPopupTrigger;
    this.infoPopupTrigger = null;
    if (trigger && trigger.isConnected && this.dialogIsOpen()) {
      try {
        trigger.focus({ preventScroll: true });
      } catch (error) {
        trigger.focus();
      }
    }
  };

  ComparisonController.prototype.onInfoPopupBackdrop = function (event) {
    if (event.target === this.elements.infoHost) this.closeInfoPopup();
  };

  ComparisonController.prototype.allWithin = function (scope, selector) {
    var elements = [];
    if (scope && scope.nodeType === 1 && scope.matches(selector)) elements.push(scope);
    if (scope && scope.querySelectorAll) {
      elements = elements.concat(Array.from(scope.querySelectorAll(selector)));
    }
    return elements;
  };

  ComparisonController.prototype.observeAddButtons = function (scope) {
    var controller = this;
    this.allWithin(scope, "[data-two-nu-compare-add]").forEach(function (button) {
      if (controller.addObservers.has(button)) return;
      if (!button.hasAttribute("data-two-nu-active-variant-id") && button.dataset.twoNuInitialVariantId) {
        button.dataset.twoNuActiveVariantId = button.dataset.twoNuInitialVariantId;
      }
      var observer = new MutationObserver(function () {
        controller.updateAddButton(button);
      });
      observer.observe(button, {
        attributes: true,
        attributeFilter: ["data-two-nu-active-variant-id", "data-two-nu-initial-variant-id"]
      });
      controller.addObservers.set(button, observer);
      controller.updateAddButton(button);
    });
  };

  ComparisonController.prototype.registerCatalogs = function (scope) {
    var controller = this;
    this.allWithin(scope, "[data-two-nu-compare-catalog]").forEach(function (script) {
      if (controller.catalogScripts.has(script)) return;
      controller.catalogScripts.add(script);
      var data = safeParse(script.textContent, null);
      if (!data || data.version !== VERSION || (!isObject(data.items) && !Array.isArray(data.items))) return;
      var entries = Array.isArray(data.items)
        ? data.items.map(function (item) { return [item && item.variantId, item]; })
        : Object.entries(data.items);
      entries.forEach(function (entry) {
        controller.registerItem(entry[1], entry[0]);
      });
    });

    this.allWithin(scope, "[data-callout-lens-family-v2-data]").forEach(function (script) {
      if (controller.catalogScripts.has(script)) return;
      controller.catalogScripts.add(script);
      var data = safeParse(script.textContent, null);
      if (!data || !Array.isArray(data.variants)) return;
      data.variants.forEach(function (variant) {
        controller.registerItem(controller.calloutItem(data, variant), variant && variant.id);
      });
    });
    var enriched = false;
    this.items = this.items.map(function (saved) {
      var catalogItem = controller.catalog.get(saved.variantId);
      if (!catalogItem) return saved;
      enriched = true;
      var merged = mergeItem(saved, catalogItem);
      if (Array.isArray(saved.gallery) && saved.gallery.length > merged.gallery.length) {
        merged.gallery = clone(saved.gallery);
      }
      merged.savedAt = saved.savedAt;
      return merged;
    });
    if (enriched) this.persist(false);
    this.updateButtons();
  };

  ComparisonController.prototype.registerItem = function (raw, fallbackId) {
    var item = normalizeItem(raw, fallbackId);
    if (!item) return null;
    var existing = this.catalog.get(item.variantId);
    var merged = mergeItem(existing, item);
    this.catalog.set(item.variantId, merged);
    return merged;
  };

  ComparisonController.prototype.calloutItem = function (data, variant) {
    var families = Array.isArray(variant.families) ? variant.families : [];
    var familyKey = slug(families[0]);
    var family = isObject(data.families) && isObject(data.families[familyKey])
      ? data.families[familyKey]
      : {};
    var isPrescription = familyKey === "pre" || familyKey === "hex_pre" || family.action === "prescription";
    var productFeatures = isObject(data.productFeatures) ? data.productFeatures : {};
    var knownPolarized = familyKey === "tvo"
      ? false
      : (["tvo_pro", "hex", "pre", "hex_pre"].indexOf(familyKey) !== -1 ? true : null);
    return {
      variantId: variant.id,
      productId: data.productId,
      productHandle: data.productHandle,
      productTitle: data.productTitle,
      canonicalUrl: variant.url || data.productUrl,
      variantTitle: variant.title || variant.sku,
      sku: firstDefined(variant.shopifySku, variant.shopify_sku, variant.sku),
      image: {
        url: variant.image,
        alt: data.productTitle
      },
      selection: {
        modelKey: data.modelKey,
        frameColorKey: variant.frameColor,
        frameColorLabel: variant.frameColorTitle,
        lensColorKey: variant.lensesColor,
        lensColorLabel: variant.lensesColorTitle,
        lensFamilyKey: familyKey,
        lensFamilyLabel: family.label,
        frameMaterialKey: variant.frameMaterial,
        frameMaterialLabel: variant.frameMaterial
      },
      profile: {
        revision: data.profileRevision || "comparison-profile-1",
        modelKey: data.modelKey,
        fitKey: slug(data.fitLabel),
        fitLabel: data.fitLabel,
        frameFeel: data.frameFeel,
        coverageKey: data.coverageKey,
        coverageLabel: data.coverageLabel,
        bestFor: data.bestFor,
        features: {
          uv400: booleanOrNull(firstDefined(variant.uv400, productFeatures.uv400)),
          polarized: booleanOrNull(firstDefined(variant.polarized, knownPolarized)),
          hexachroma: familyKey === "hex" || familyKey === "hex_pre",
          metonic: booleanOrNull(firstDefined(variant.metonic, productFeatures.metonic)),
          flexfoam: booleanOrNull(firstDefined(variant.flexfoam, productFeatures.flexfoam)),
          floatMax: booleanOrNull(firstDefined(variant.floatMax, family.floatMax, productFeatures.float_max)),
          prescription: isPrescription
        },
        activityScores: variant.activityScores,
        aiTryOn: isObject(variant.aiTryOn)
          ? variant.aiTryOn
          : { available: booleanOrNull(data.aiTryOn) },
        physicalTryOn: isObject(data.physicalTryOn)
          ? data.physicalTryOn
          : {
              available: Boolean(data.physicalTryOnUrl),
              url: data.physicalTryOnUrl
            },
        prescription: {
          isPrescription: isPrescription,
          limitLabel: family.limitLabel || ""
        }
      },
      commerce: {
        price: variant.price,
        compareAtPrice: firstDefined(variant.compareAtPrice, variant.compare_at_price),
        available: variant.available,
        currency: data.currency,
        marketSignature: data.marketSignature,
        capturedAt: nowIso(),
        source: "liquid"
      }
    };
  };

  ComparisonController.prototype.getButtonVariantId = function (button) {
    return cleanId(firstDefined(
      button && button.dataset.twoNuActiveVariantId,
      button && button.dataset.twoNuInitialVariantId
    ));
  };

  ComparisonController.prototype.minimalItemFromButton = function (button, variantId) {
    var activityScores = safeParse(button.dataset.activityScores || "", {});
    return normalizeItem({
      variantId: variantId,
      productHandle: button.dataset.productHandle,
      productTitle: button.dataset.productTitle,
      productUrl: button.dataset.productUrl || button.dataset.variantUrl,
      variantTitle: button.dataset.variantTitle || button.dataset.variantLabel,
      sku: firstDefined(button.dataset.shopifySku, button.dataset.variantSku, button.dataset.sku),
      image: button.dataset.variantImage,
      frameColorTitle: button.dataset.frameColorTitle,
      lensesColorTitle: button.dataset.lensesColorTitle,
      lensFamilyKey: button.dataset.lensFamily,
      frameMaterialKey: button.dataset.frameMaterial,
      modelKey: button.dataset.model,
      fitLabel: button.dataset.fitLabel,
      activityScores: activityScores,
      price: button.dataset.price,
      compareAtPrice: button.dataset.compareAtPrice,
      currency: button.dataset.currency,
      available: button.dataset.available,
      aiTryOnAvailable: button.dataset.aiTryonAvailable
    }, variantId);
  };

  ComparisonController.prototype.itemForButton = function (button) {
    var variantId = this.getButtonVariantId(button);
    if (!variantId) return null;
    if (this.catalog.has(variantId)) return clone(this.catalog.get(variantId));
    var localRoot = button.closest("[data-callout-lens-family-v2-item], [data-two-nu-compare-surface], section");
    if (localRoot) this.registerCatalogs(localRoot);
    if (this.catalog.has(variantId)) return clone(this.catalog.get(variantId));
    var minimal = this.minimalItemFromButton(button, variantId);
    if (minimal) this.catalog.set(variantId, minimal);
    return minimal;
  };

  ComparisonController.prototype.has = function (variantId) {
    var id = cleanId(variantId);
    return Boolean(id) && this.items.some(function (item) { return item.variantId === id; });
  };

  ComparisonController.prototype.getState = function () {
    return {
      version: VERSION,
      maxItems: MAX_ITEMS,
      persistent: this.store.persistent,
      items: clone(this.items),
      pendingReplacement: this.pendingReplacement ? clone(this.pendingReplacement) : null
    };
  };

  ComparisonController.prototype.persist = function (touch) {
    var state = this.store.save(this.items, { touch: touch !== false });
    this.items = clone(state.items);
  };

  ComparisonController.prototype.add = function (rawItem, options) {
    var item = normalizeItem(rawItem, rawItem && rawItem.variantId);
    var source = cleanString(options && options.source, 80) || "unknown";
    var trigger = options && options.trigger;
    if (!item) {
      this.emit("two-nu:compare-error", { action: "add", code: "INVALID_ITEM", source: source });
      return { status: "invalid", count: this.items.length };
    }
    if (this.has(item.variantId)) {
      this.open({ source: source, trigger: trigger });
      return { status: "exists", count: this.items.length };
    }
    if (this.items.length >= MAX_ITEMS) {
      this.pendingReplacement = item;
      this.open({ source: source, trigger: trigger });
      this.render();
      this.focusReplacement();
      this.emit("two-nu:compare-full", {
        source: source,
        count: this.items.length,
        pendingVariantId: item.variantId
      });
      return { status: "full", count: this.items.length };
    }

    var before = clone(this.items);
    item.savedAt = nowIso();
    this.runtimeStatus.delete(item.variantId);
    this.items.push(item);
    this.activeIndex = this.items.length - 1;
    this.lastUndoItems = before;
    this.persist(true);
    this.render();
    if (this.dialogIsOpen()) this.hydrateGalleries();
    var message = this.label("addedToComparison", "", { count: this.items.length });
    if (!this.store.persistent) message += " " + this.label("savedVisitOnly");
    this.showToast(message, true, true);
    this.announce(message);
    this.emitChange("add", source, item.variantId);
    return { status: "added", count: this.items.length };
  };

  ComparisonController.prototype.remove = function (variantId, options) {
    var id = cleanId(variantId);
    var index = this.items.findIndex(function (item) { return item.variantId === id; });
    if (index === -1) return { status: "not-found", count: this.items.length };
    var before = clone(this.items);
    this.items.splice(index, 1);
    this.runtimeStatus.delete(id);
    this.activeIndex = Math.max(0, Math.min(this.activeIndex, this.items.length - 1));
    this.lastUndoItems = before;
    this.persist(true);
    this.render();
    this.showToast(this.label("removedFromComparison"), true, true);
    this.announce(this.label("removedFromComparison"));
    this.emitChange("remove", cleanString(options && options.source, 80) || "dialog", id);
    return { status: "removed", count: this.items.length };
  };

  ComparisonController.prototype.replace = function (oldVariantId, rawItem, options) {
    var oldId = cleanId(oldVariantId);
    var item = normalizeItem(rawItem, rawItem && rawItem.variantId);
    var index = this.items.findIndex(function (entry) { return entry.variantId === oldId; });
    if (index === -1) return { status: "not-found", count: this.items.length };
    if (!item) return { status: "invalid", count: this.items.length };
    if (this.items.some(function (entry, itemIndex) {
      return itemIndex !== index && entry.variantId === item.variantId;
    })) {
      return { status: "duplicate", count: this.items.length };
    }
    var before = clone(this.items);
    item.savedAt = nowIso();
    this.runtimeStatus.delete(oldId);
    this.runtimeStatus.delete(item.variantId);
    this.items.splice(index, 1, item);
    this.activeIndex = index;
    this.pendingReplacement = null;
    this.lastUndoItems = before;
    this.persist(true);
    this.render();
    if (this.dialogIsOpen()) this.hydrateGalleries();
    this.showToast(this.label("replaced"), true, true);
    this.announce(this.label("replaced"));
    this.emitChange("replace", cleanString(options && options.source, 80) || "dialog", item.variantId);
    return { status: "replaced", count: this.items.length };
  };

  ComparisonController.prototype.clear = function (options) {
    if (!this.items.length) return { status: "cleared", count: 0 };
    this.lastUndoItems = clone(this.items);
    this.items = [];
    this.runtimeStatus.clear();
    this.pendingReplacement = null;
    this.activeIndex = 0;
    this.persist(true);
    this.render();
    this.showToast(this.label("cleared"), true, false);
    this.announce(this.label("cleared"));
    this.emitChange("clear", cleanString(options && options.source, 80) || "dialog", "");
    return { status: "cleared", count: 0 };
  };

  ComparisonController.prototype.restoreUndo = function () {
    if (!Array.isArray(this.lastUndoItems)) return;
    var previous = clone(this.items);
    this.items = this.lastUndoItems.map(function (item) {
      return normalizeItem(item, item.variantId);
    }).filter(Boolean).slice(0, MAX_ITEMS);
    this.runtimeStatus.clear();
    this.lastUndoItems = previous;
    this.pendingReplacement = null;
    this.activeIndex = Math.max(0, Math.min(this.activeIndex, this.items.length - 1));
    this.persist(true);
    this.render();
    if (this.dialogIsOpen()) this.hydrateGalleries();
    this.hideToast();
    this.announce(this.label("replaced"));
    this.emitChange("undo", "toast", "");
  };

  ComparisonController.prototype.emit = function (name, detail, cancelable) {
    var payload = Object.assign({ version: VERSION }, detail || {});
    var event = new CustomEvent(name, {
      bubbles: true,
      cancelable: Boolean(cancelable),
      detail: payload
    });
    document.dispatchEvent(event);
    return event;
  };

  ComparisonController.prototype.emitChange = function (action, source, variantId) {
    this.emit("two-nu:compare-change", {
      action: action,
      source: source,
      count: this.items.length,
      variantId: variantId || null,
      variantIds: this.items.map(function (item) { return item.variantId; })
    });
  };

  ComparisonController.prototype.dialogIsOpen = function () {
    return Boolean(this.elements.dialog && this.elements.dialog.hasAttribute("open"));
  };

  ComparisonController.prototype.placeFeedback = function () {
    if (!this.root) return;
    var panel = this.elements.dialog && this.elements.dialog.querySelector(".two-nu-compare__panel");
    var destination = this.dialogIsOpen() && panel ? panel : this.root;
    [this.elements.toast, this.elements.live].forEach(function (element) {
      if (element && element.parentElement !== destination) destination.appendChild(element);
    });
  };

  ComparisonController.prototype.open = function (options) {
    this.bindRoot();
    this.hideToast();
    if (!this.elements.dialog) return { status: "unavailable" };
    var wasOpen = this.dialogIsOpen();
    var trigger = options && options.trigger;
    if (trigger && trigger instanceof HTMLElement) this.lastFocus = trigger;
    else if (document.activeElement instanceof HTMLElement) this.lastFocus = document.activeElement;
    this.persist(true);
    if (typeof window.twoNuCloseActivitySelector === "function") {
      window.twoNuCloseActivitySelector("dock-switch", {
        persist: false,
        focus: false,
        immediate: true
      });
    }
    if (typeof window.twoNuCloseSearchPopup === "function") {
      window.twoNuCloseSearchPopup({ immediate: true, focus: false });
    }
    if (typeof window.twoNuCloseDockPopovers === "function") {
      window.twoNuCloseDockPopovers({ immediate: true, focus: false });
    }
    if (typeof window.twoNuCloseDockCart === "function") {
      window.twoNuCloseDockCart({ immediate: true, focus: false });
    }
    this.closeOtherOverlays();
    this.lockPage();
    this.runtimeStatus.clear();
    this.render();
    if (!this.dialogIsOpen()) {
      if (typeof this.elements.dialog.show === "function") {
        this.elements.dialog.show();
      } else {
        this.elements.dialog.setAttribute("open", "");
      }
      this.elements.dialog.removeAttribute("aria-modal");
    }
    this.placeFeedback();
    this.hydrateGalleries();
    if (!wasOpen) this.refresh().catch(function () {});
    document.querySelectorAll("[data-two-nu-compare-open]").forEach(function (button) {
      button.setAttribute("aria-expanded", "true");
    });
    var controller = this;
    window.requestAnimationFrame(function () {
      var popupSurface = controller.elements.dialog;
      var popupMotion = null;
      if (
        !wasOpen
        && window.twoNuDockPopupMotion
        && typeof window.twoNuDockPopupMotion.open === "function"
      ) {
        popupMotion = window.twoNuDockPopupMotion.open(
          popupSurface,
          trigger || controller.lastFocus
        );
      }
      controller.alignTrackToActive("auto");
      if (controller.pendingReplacement) controller.focusReplacement();
      else if (controller.elements.heading) controller.elements.heading.focus({ preventScroll: true });
      controller.drawRadar();
      if (popupMotion && typeof popupMotion.then === "function") {
        popupMotion.then(function () {
          if (controller.dialogIsOpen()) controller.drawRadars();
        });
      }
    });
    this.emit("two-nu:compare-open", {
      source: cleanString(options && options.source, 80) || "unknown",
      count: this.items.length,
      variantIds: this.items.map(function (item) { return item.variantId; })
    });
    return { status: "opened", count: this.items.length };
  };

  ComparisonController.prototype.close = function (reason, options) {
    if (!this.elements.dialog || !this.dialogIsOpen()) return { status: "closed" };
    var controller = this;
    var settings = options || {};
    var popupSurface = this.elements.dialog;
    var finish = function () {
      controller.popupMotionClosing = false;
      if (!controller.dialogIsOpen()) return;
      document.querySelectorAll("[data-two-nu-compare-open]").forEach(function (button) {
        button.setAttribute("aria-expanded", "false");
      });
      if (typeof controller.elements.dialog.close === "function") {
        controller.elements.dialog.close();
      } else {
        controller.elements.dialog.removeAttribute("open");
        controller.onDialogClosed();
      }
    };
    this.closeReason = reason || "close";
    this.suppressFocusRestore = Boolean(settings.suppressFocusRestore);
    if (
      settings.immediate
      || !window.twoNuDockPopupMotion
      || typeof window.twoNuDockPopupMotion.close !== "function"
      || !(popupSurface instanceof Element)
    ) {
      if (
        popupSurface
        && window.twoNuDockPopupMotion
        && typeof window.twoNuDockPopupMotion.cancel === "function"
      ) {
        window.twoNuDockPopupMotion.cancel(popupSurface);
      }
      finish();
      return { status: "closed" };
    }
    if (this.popupMotionClosing) return { status: "closing" };
    this.popupMotionClosing = true;
    window.twoNuDockPopupMotion.close(popupSurface, this.lastFocus).then(finish);
    return { status: "closing" };
  };

  ComparisonController.prototype.onDialogCancel = function (event) {
    event.preventDefault();
    if (this.aiTryOnLayer || this.infoPopupIsOpen() || Date.now() < this.nestedEscapeUntil) return;
    if (this.pendingReplacement) {
      this.pendingReplacement = null;
      this.render();
      if (this.elements.heading) this.elements.heading.focus({ preventScroll: true });
      return;
    }
    this.close("escape");
  };

  ComparisonController.prototype.onDialogClosed = function () {
    this.popupMotionClosing = false;
    window.clearTimeout(this.aiTryOnRootTimer);
    this.aiTryOnRootTimer = 0;
    if (this.infoPopupIsOpen()) this.closeInfoPopup();
    this.cleanupAiTryOnLayer(false);
    this.unlockPage();
    this.placeFeedback();
    document.querySelectorAll("[data-two-nu-compare-open]").forEach(function (button) {
      button.setAttribute("aria-expanded", "false");
    });
    if (!this.suppressFocusRestore && this.lastFocus && this.lastFocus.isConnected) {
      try {
        this.lastFocus.focus({ preventScroll: true });
      } catch (error) {
        this.lastFocus.focus();
      }
    }
    this.suppressFocusRestore = false;
    this.emit("two-nu:compare-close", {
      reason: this.closeReason || "close",
      count: this.items.length
    });
  };

  ComparisonController.prototype.onDialogBackdrop = function (event) {
    if (event.target === this.elements.dialog) this.close("backdrop");
  };

  ComparisonController.prototype.closeOtherOverlays = function () {
    document.querySelectorAll(
      "[data-two-nu-dock-popover]:not([hidden]), [data-product-dock-popover]:not([hidden])"
    ).forEach(function (popover) {
      popover.hidden = true;
    });
    document.querySelectorAll("[data-two-nu-dock-control], [data-product-dock-control]").forEach(function (control) {
      control.setAttribute("aria-expanded", "false");
    });
  };

  ComparisonController.prototype.lockPage = function () {
    if (this.scrollLock) return;
    var body = document.body;
    var page = document.documentElement;
    var y = window.scrollY;
    this.scrollLock = {
      x: window.scrollX,
      y: y,
      bodyStyles: {},
      scrollBehavior: page.style.getPropertyValue("scroll-behavior"),
      scrollBehaviorPriority: page.style.getPropertyPriority("scroll-behavior")
    };
    var lock = this.scrollLock;
    ["position", "top", "left", "right", "width", "overflow"].forEach(function (property) {
      lock.bodyStyles[property] = {
        value: body.style.getPropertyValue(property),
        priority: body.style.getPropertyPriority(property)
      };
    });
    // The theme normally smooth-scrolls anchors. A fixed-body lock must never
    // animate the document from zero when its original position is restored.
    page.style.setProperty("scroll-behavior", "auto", "important");
    body.style.position = "fixed";
    body.style.top = "-" + y + "px";
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
    body.style.overflow = "hidden";
    body.classList.add("two-nu-compare-open");
    body.classList.add("two-nu-compare-is-open");
    document.documentElement.classList.add("two-nu-compare-is-open");
  };

  ComparisonController.prototype.unlockPage = function () {
    if (!this.scrollLock) return;
    var body = document.body;
    var page = document.documentElement;
    var lock = this.scrollLock;
    Object.keys(lock.bodyStyles).forEach(function (property) {
      var previous = lock.bodyStyles[property];
      if (previous.value) body.style.setProperty(property, previous.value, previous.priority);
      else body.style.removeProperty(property);
    });
    body.classList.remove("two-nu-compare-open");
    body.classList.remove("two-nu-compare-is-open");
    document.documentElement.classList.remove("two-nu-compare-is-open");
    this.scrollLock = null;
    try {
      window.scrollTo({ left: lock.x, top: lock.y, behavior: "instant" });
    } finally {
      if (lock.scrollBehavior) page.style.setProperty("scroll-behavior", lock.scrollBehavior, lock.scrollBehaviorPriority);
      else page.style.removeProperty("scroll-behavior");
    }
  };

  ComparisonController.prototype.focusReplacement = function () {
    if (!this.elements.replacement) return;
    var heading = this.elements.replacement.querySelector("h3");
    if (heading) {
      heading.tabIndex = -1;
      heading.focus({ preventScroll: true });
    }
  };

  ComparisonController.prototype.guardNonModalClick = function (event) {
    if (
      !this.dialogIsOpen()
      || this.aiTryOnLayer
      || this.infoPopupIsOpen()
      || !(event.target instanceof Element)
    ) return;
    if (
      this.elements.dialog.contains(event.target)
      || event.target.closest("[data-two-nu-global-dock]")
    ) return;
    event.preventDefault();
    event.stopPropagation();
    this.close("backdrop");
  };

  ComparisonController.prototype.handleClick = function (event) {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest("[data-two-nu-compare-info-close]")) {
      event.preventDefault();
      this.closeInfoPopup();
      return;
    }
    var featureInfo = event.target.closest("[data-two-nu-compare-feature-info]");
    if (featureInfo) {
      event.preventDefault();
      event.stopPropagation();
      var featureKey = cleanString(featureInfo.dataset.twoNuCompareFeatureInfo, 80);
      this.openInfoPopup(this.featureLabel(featureKey), this.featureInfo(featureKey), featureInfo);
      return;
    }
    var fitInfo = event.target.closest("[data-two-nu-compare-fit-info]");
    if (fitInfo) {
      event.preventDefault();
      event.stopPropagation();
      var fitKey = cleanString(fitInfo.dataset.twoNuCompareFitInfo, 120);
      var fitPopup = this.fitInfo(fitKey);
      if (fitPopup) {
        this.openInfoPopup(
          cleanString(fitPopup.title, 240) || this.label("fitDialogTitle"),
          String(fitPopup.html || ""),
          fitInfo
        );
      }
      return;
    }
    var addButton = event.target.closest("[data-two-nu-compare-add]");
    if (addButton) {
      event.preventDefault();
      var item = this.itemForButton(addButton);
      if (item) {
        this.add(item, {
          source: addButton.dataset.twoNuCompareContext || addButton.dataset.compareSource || "product",
          trigger: addButton
        });
      } else {
        this.emit("two-nu:compare-error", { action: "add", code: "CATALOG_ITEM_NOT_FOUND" });
      }
      return;
    }

    var openButton = event.target.closest("[data-two-nu-compare-open]");
    if (openButton) {
      event.preventDefault();
      var isGlobalDockToggle = openButton.dataset.twoNuCompareContext === "global-dock" ||
        openButton.matches('[data-two-nu-global-control="compare"]');
      if (isGlobalDockToggle && this.dialogIsOpen()) {
        this.close("dock-toggle");
        return;
      }
      this.open({
        source: openButton.dataset.twoNuCompareContext || "dock",
        trigger: openButton
      });
      return;
    }
    if (event.target.closest("[data-two-nu-compare-close]")) {
      event.preventDefault();
      this.close("button");
      return;
    }
    if (event.target.closest("[data-two-nu-compare-clear]")) {
      event.preventDefault();
      this.clear({ source: "dialog" });
      return;
    }
    var remove = event.target.closest("[data-two-nu-compare-remove]");
    if (remove) {
      event.preventDefault();
      this.remove(remove.dataset.twoNuCompareRemove, { source: "dialog" });
      return;
    }
    var replace = event.target.closest("[data-two-nu-compare-replace-id]");
    if (replace && this.pendingReplacement) {
      event.preventDefault();
      this.replace(replace.dataset.twoNuCompareReplaceId, this.pendingReplacement, { source: "replacement" });
      return;
    }
    if (event.target.closest("[data-two-nu-compare-replacement-cancel]")) {
      event.preventDefault();
      this.pendingReplacement = null;
      this.render();
      if (this.elements.heading) this.elements.heading.focus({ preventScroll: true });
      return;
    }
    if (event.target.closest("[data-two-nu-compare-prev], [data-two-nu-compare-previous]")) {
      event.preventDefault();
      this.setActiveIndex(this.activeIndex - 1, true);
      return;
    }
    if (event.target.closest("[data-two-nu-compare-next]")) {
      event.preventDefault();
      this.setActiveIndex(this.activeIndex + 1, true);
      return;
    }
    var galleryNext = event.target.closest("[data-two-nu-compare-gallery-next]");
    if (galleryNext) {
      event.preventDefault();
      event.stopPropagation();
      this.cycleGallery(galleryNext);
      return;
    }
    var legend = event.target.closest("[data-two-nu-compare-legend-index]");
    if (legend) {
      event.preventDefault();
      this.setActiveIndex(Number(legend.dataset.twoNuCompareLegendIndex), true);
      return;
    }
    var cart = event.target.closest("[data-two-nu-compare-cart]");
    if (cart) {
      event.preventDefault();
      this.addExactVariantToCart(cart.dataset.twoNuCompareCart, cart);
      return;
    }
    var aiTryOn = event.target.closest("[data-two-nu-compare-ai-tryon]");
    if (aiTryOn) {
      event.preventDefault();
      this.handoffAiTryOn(aiTryOn.dataset.twoNuCompareAiTryon, aiTryOn);
      return;
    }
    if (event.target.closest("[data-two-nu-compare-toast-view]")) {
      event.preventDefault();
      this.open({ source: "toast", trigger: event.target.closest("button") });
      return;
    }
    if (event.target.closest("[data-two-nu-compare-toast-undo]")) {
      event.preventDefault();
      this.restoreUndo();
      return;
    }
    var card = event.target.closest("[data-two-nu-compare-card-index]");
    if (card && !event.target.closest("a, button, input, select, textarea")) {
      this.setActiveIndex(Number(card.dataset.twoNuCompareCardIndex), false);
    }
  };

  ComparisonController.prototype.handleKeydown = function (event) {
    if (!(event.target instanceof Element)) return;
    if (
      this.dialogIsOpen()
      && !this.aiTryOnLayer
      && !this.infoPopupIsOpen()
      && Date.now() >= this.nestedEscapeUntil
    ) {
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        if (this.pendingReplacement) {
          this.pendingReplacement = null;
          this.render();
          if (this.elements.heading) {
            this.elements.heading.focus({ preventScroll: true });
          }
        } else {
          this.close("escape");
        }
        return;
      }
      if (event.key === "Tab") {
        var focusable = Array.from(this.elements.dialog.querySelectorAll(
          "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), " +
          "textarea:not([disabled]), [tabindex]:not([tabindex='-1'])"
        )).filter(function (element) {
          var style = window.getComputedStyle(element);
          var rect = element.getBoundingClientRect();
          return style.display !== "none" &&
            style.visibility !== "hidden" &&
            rect.width > 0 &&
            rect.height > 0;
        });
        if (!focusable.length) {
          event.preventDefault();
          if (this.elements.heading) this.elements.heading.focus({ preventScroll: true });
          return;
        }
        var activeIndex = focusable.indexOf(document.activeElement);
        var moveToEnd = event.shiftKey && activeIndex <= 0;
        var moveToStart = !event.shiftKey &&
          (activeIndex === -1 || activeIndex === focusable.length - 1);
        if (moveToEnd || moveToStart) {
          event.preventDefault();
          focusable[moveToEnd ? focusable.length - 1 : 0].focus({ preventScroll: true });
          return;
        }
      }
    }
    var card = event.target.closest("[data-two-nu-compare-card-index]");
    if (!card || (event.key !== "Enter" && event.key !== " ")) return;
    if (event.target.closest("a, button")) return;
    event.preventDefault();
    this.setActiveIndex(Number(card.dataset.twoNuCompareCardIndex), false);
  };

  ComparisonController.prototype.handleVariantChange = function (event) {
    var detail = isObject(event.detail) ? event.detail : {};
    var variantId = cleanId(detail.variantId);
    if (detail.item) this.registerItem(detail.item, variantId);
    if (!variantId) return;
    var scope = event.target instanceof Element ? event.target : document;
    this.allWithin(scope, "[data-two-nu-compare-add]").forEach(function (button) {
      button.dataset.twoNuActiveVariantId = variantId;
    });
    this.observeAddButtons(scope);
    this.updateButtons();
  };

  ComparisonController.prototype.handleStorage = function (event) {
    if (event.key !== STORAGE_KEY) return;
    var external = this.store.readExternal();
    if (!external) return;
    this.items = clone(external.items);
    this.runtimeStatus.clear();
    this.pendingReplacement = null;
    this.activeIndex = Math.max(0, Math.min(this.activeIndex, this.items.length - 1));
    this.render();
    this.emitChange("sync", "storage", "");
  };

  ComparisonController.prototype.updateAddButton = function (button) {
    var id = this.getButtonVariantId(button);
    var saved = this.has(id);
    var label = saved ? this.label("addedView") : this.label("add");
    button.dataset.twoNuCompareState = saved ? "saved" : "available";
    button.classList.toggle("is-saved", saved);
    button.setAttribute("aria-label", label);
    button.setAttribute("aria-pressed", saved ? "true" : "false");
    var labelNode = button.querySelector("[data-two-nu-compare-add-label]");
    if (!labelNode) return;
    if (!saved) {
      labelNode.textContent = label;
      return;
    }
    var parts = label.split("·");
    var status = cleanString(parts.shift(), 160) || label;
    var action = cleanString(parts.join("·"), 240);
    var statusLine = createElement("span", "two-nu-compare-button__saved-status", status + (action ? " ·" : ""));
    labelNode.replaceChildren(statusLine);
    if (action) {
      labelNode.appendChild(createElement("span", "two-nu-compare-button__saved-action", action));
    }
  };

  ComparisonController.prototype.updateButtons = function () {
    var controller = this;
    document.querySelectorAll("[data-two-nu-compare-add]").forEach(function (button) {
      controller.updateAddButton(button);
    });
    var count = this.items.length;
    document.querySelectorAll("[data-two-nu-compare-count]").forEach(function (badge) {
      badge.textContent = count ? String(count) : "";
      badge.classList.toggle("is-empty", count === 0);
      badge.setAttribute("aria-hidden", count ? "false" : "true");
    });
    document.querySelectorAll("[data-two-nu-compare-open]").forEach(function (button) {
      button.setAttribute("aria-label", count
        ? controller.label("openCount", "", { count: count })
        : controller.label("open"));
    });
  };

  ComparisonController.prototype.render = function () {
    this.bindRoot();
    this.updateButtons();
    if (!this.root) return;
    var count = this.items.length;
    this.activeIndex = Math.max(0, Math.min(this.activeIndex, Math.max(0, count - 1)));
    this.root.dataset.twoNuCompareState = this.pendingReplacement
      ? "replacement"
      : (count ? "ready" : "empty");
    if (this.elements.dialogCount) {
      this.elements.dialogCount.textContent = this.label("count", "", { count: count });
    }
    if (this.elements.clear) this.elements.clear.disabled = count === 0;
    if (this.elements.empty) this.elements.empty.hidden = count !== 0 || Boolean(this.pendingReplacement);
    if (this.elements.main) this.elements.main.hidden = count === 0 || Boolean(this.pendingReplacement);
    if (this.elements.replacement) this.elements.replacement.hidden = !this.pendingReplacement;
    if (this.pendingReplacement) this.renderReplacement();
    this.renderCards();
    this.renderLegend();
    this.renderMobileDetails();
    this.updateActiveVisuals();
    if (this.dialogIsOpen()) {
      var controller = this;
      window.requestAnimationFrame(function () {
        controller.alignTrackToActive("auto");
        controller.drawRadars();
      });
    }
  };

  ComparisonController.prototype.modelCopy = function (item, key) {
    var modelKey = item.selection.modelKey || item.profile.modelKey;
    var model = isObject(this.i18n.models && this.i18n.models[modelKey])
      ? this.i18n.models[modelKey]
      : {};
    if (key === "frameFeel") return item.profile.frameFeel || model.frameFeel || item.profile.shapeLabel;
    if (key === "coverage") return item.profile.coverageLabel || model.coverage;
    if (key === "bestFor") return item.profile.bestFor || model.bestFor;
    return "";
  };

  ComparisonController.prototype.variantLabel = function (item) {
    var customerLabel = [
      item.selection.frameColorLabel,
      item.selection.lensColorLabel,
      item.selection.lensFamilyLabel || this.familyLabel(item.selection.lensFamilyKey)
    ].filter(Boolean).join(" / ");
    if (customerLabel) return customerLabel;

    var variantTitle = cleanString(item.variantTitle, 300);
    if (!variantTitle || variantTitle.toLowerCase() === "default title") return "";
    if (/^[A-Z0-9]{4,}(?:-[A-Z0-9]{1,})+$/i.test(variantTitle)) return "";
    return variantTitle;
  };

  ComparisonController.prototype.currentCurrency = function (item) {
    return cleanString(firstDefined(
      this.root && this.root.dataset.currency,
      window.Shopify && window.Shopify.currency && window.Shopify.currency.active,
      item && item.commerce.currency
    ), 8).toUpperCase();
  };

  ComparisonController.prototype.formatMoney = function (minorUnits, currency) {
    var amount = numberOrNull(minorUnits);
    if (amount === null) return "";
    var code = cleanString(currency, 8).toUpperCase() || "HKD";
    var locale = cleanString(
      firstDefined(this.root && this.root.dataset.locale, document.documentElement.lang, "en"),
      30
    );
    try {
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: code
      }).format(amount / 100);
    } catch (error) {
      return code + " " + (amount / 100).toFixed(2);
    }
  };

  ComparisonController.prototype.availabilityLabel = function (item) {
    var status = this.runtimeStatus.get(item.variantId);
    if (status === "unresolved") return this.label("unavailable");
    if (item.commerce.available === false || status === "sold-out") return this.label("soldOut");
    if (item.commerce.available === true || status === "fresh") return this.label("available");
    return this.label("unavailable");
  };

  ComparisonController.prototype.commerceIsCurrent = function (item) {
    var currentMarket = this.marketSignature();
    var savedMarket = cleanString(item.commerce.marketSignature, 240);
    var correctMarket = !currentMarket || !savedMarket || savedMarket === currentMarket;
    return correctMarket && numberOrNull(item.commerce.price) !== null;
  };

  ComparisonController.prototype.updateCommerceCard = function (item) {
    if (!this.root || !item) return;
    var card = this.root.querySelector("article[data-variant-id='" + item.variantId + "']");
    if (!card) return;
    var sku = card.querySelector("[data-two-nu-compare-sku]");
    if (sku) {
      sku.textContent = item.sku || "";
      sku.hidden = !item.sku;
      if (item.sku) sku.setAttribute("aria-label", "SKU " + item.sku);
      else sku.removeAttribute("aria-label");
    }
    var price = card.querySelector(".two-nu-compare__card-price");
    if (price) {
      price.replaceChildren();
      if (this.commerceIsCurrent(item)) {
        if (item.commerce.compareAtPrice !== null && item.commerce.price !== null && item.commerce.compareAtPrice > item.commerce.price) {
          price.appendChild(createElement("del", "", this.formatMoney(item.commerce.compareAtPrice, this.currentCurrency(item))));
          price.appendChild(document.createTextNode(" "));
        }
        price.appendChild(createElement("span", "", this.formatMoney(item.commerce.price, this.currentCurrency(item))));
        price.hidden = false;
      } else price.hidden = true;
    }
    var status = this.runtimeStatus.get(item.variantId) || "unknown";
    var availability = card.querySelector(".two-nu-compare__card-availability");
    if (availability) {
      availability.textContent = this.availabilityLabel(item);
      availability.dataset.state = status === "unresolved" ? "unavailable" : (status === "sold-out" ? "sold-out" : (item.commerce.available === true ? "fresh" : "unavailable"));
      availability.dataset.available = item.commerce.available === true ? "true" : "false";
    }
    var button = card.querySelector("[data-two-nu-compare-cart]");
    if (button && !this.pendingCartIds.has(item.variantId)) {
      var state = this.purchaseState(item);
      var label = this.isPrescription(item) ? this.label("orderNow") : this.label("addToCart");
      if (state === "sold-out") label = this.label("soldOut");
      else if (state === "unavailable") label = this.label("unavailable");
      button.textContent = label;
      button.disabled = !this.canUsePurchase(item);
      button.dataset.twoNuComparePurchaseState = state;
      button.setAttribute("aria-label", label + ": " + this.accessibleItemLabel(item));
      button.removeAttribute("aria-busy");
      if (state !== "unavailable") button.classList.remove("is-error");
    }
  };

  ComparisonController.prototype.fieldMap = function (item) {
    return {
      fit: this.fitLabelForItem(item),
      lensFamily: item.selection.lensFamilyLabel || this.familyLabel(item.selection.lensFamilyKey),
      frameMaterial: item.selection.frameMaterialLabel || humanize(item.selection.frameMaterialKey)
    };
  };

  ComparisonController.prototype.renderCards = function () {
    if (!this.elements.cards) return;
    var controller = this;
    var previousActiveId = this.items[this.activeIndex] && this.items[this.activeIndex].variantId;
    this.elements.cards.replaceChildren();
    this.items.forEach(function (item, index) {
      var card = controller.createCard(item, index);
      controller.elements.cards.appendChild(card);
    });
    for (var slot = this.items.length; slot < MAX_ITEMS; slot += 1) {
      var placeholder = createElement("div", "two-nu-compare__slot");
      placeholder.setAttribute("aria-hidden", "true");
      if (slot === this.items.length) {
        placeholder.textContent = this.label("oneMore");
        placeholder.removeAttribute("aria-hidden");
      }
      this.elements.cards.appendChild(placeholder);
    }
    if (previousActiveId) {
      var found = this.items.findIndex(function (item) { return item.variantId === previousActiveId; });
      if (found !== -1) this.activeIndex = found;
    }
  };

  ComparisonController.prototype.fitOptionLabel = function (key) {
    return cleanString(this.i18n.fitOptions && this.i18n.fitOptions[key], 120) || humanize(key);
  };

  ComparisonController.prototype.fitLabelForItem = function (item) {
    var modelKey = item && (item.selection.modelKey || item.profile.modelKey);
    return cleanString(firstDefined(
      item && item.profile.fitLabel,
      item && humanize(item.profile.fitKey),
      MODEL_FIT_LABELS[modelKey]
    ), 260);
  };

  ComparisonController.prototype.fitPopupKeyForItem = function (item) {
    var text = this.fitLabelForItem(item).toLowerCase();
    if (!text) return "";
    if (text.indexOf("flexible") !== -1) return "size-flexible";
    if (text.indexOf("normal") !== -1 && (text.indexOf("smaller") !== -1 || text.indexOf("small") !== -1)) {
      return "normal-smaller";
    }
    if (text.indexOf("normal") !== -1 && (text.indexOf("larger") !== -1 || text.indexOf("large") !== -1)) {
      return "normal-larger";
    }
    if (text.indexOf("larger") !== -1 || text.indexOf("large") !== -1) return "size-larger";
    if (text.indexOf("normal") !== -1) return "size-normal";
    return "";
  };

  ComparisonController.prototype.activeHeadShapes = function (fitLabel) {
    var text = cleanString(fitLabel, 260).toLowerCase();
    if (!text) return [];
    if (text.indexOf("flexible") !== -1) return HEAD_SHAPE_ORDER.slice();
    if (text.indexOf("smaller") !== -1 || text.indexOf("small") !== -1) {
      return ["standard_small", "standard"];
    }
    if (text.indexOf("normal") !== -1 && text.indexOf("larger") !== -1) {
      return ["standard", "standard_wide", "wide_fit"];
    }
    if (text.indexOf("larger") !== -1 || text.indexOf("large") !== -1) {
      return ["standard_wide", "wide_fit"];
    }
    if (text.indexOf("normal") !== -1) {
      return ["standard_small", "standard", "standard_wide"];
    }
    return ["standard_small", "standard", "standard_wide"];
  };

  ComparisonController.prototype.createHeadFit = function (item) {
    var controller = this;
    var activeKeys = this.activeHeadShapes(this.fitLabelForItem(item));
    if (!activeKeys.length) return null;
    var active = new Set(activeKeys);
    var wrapper = createElement("div", "two-nu-compare__head-fit");
    wrapper.dataset.twoNuCompareField = "fit";
    var title = createElement("p", "two-nu-compare__head-fit-title", this.label("fit"));
    var fitPopupKey = this.fitPopupKeyForItem(item);
    var hasFitPopup = Boolean(fitPopupKey && this.fitInfo(fitPopupKey));
    var options = createElement(hasFitPopup ? "button" : "div", "two-nu-compare__head-fit-options");
    if (hasFitPopup) {
      options.type = "button";
      options.dataset.twoNuCompareFitInfo = fitPopupKey;
      options.setAttribute("aria-haspopup", "dialog");
    } else {
      options.setAttribute("role", "list");
    }
    options.setAttribute(
      "aria-label",
      this.label("fit") + ": " + activeKeys.map(function (key) {
        return controller.fitOptionLabel(key);
      }).join(", ")
    );
    HEAD_SHAPE_ORDER.forEach(function (key) {
      var option = createElement(
        "span",
        "two-nu-compare__head-option two-nu-compare__head-option--" + key.replace(/_/g, "-") +
          (active.has(key) ? " two-nu-compare__head-option--active" : "")
      );
      if (!hasFitPopup) option.setAttribute("role", "listitem");
      option.dataset.twoNuCompareFitActive = active.has(key) ? "true" : "false";
      if (active.has(key)) option.setAttribute("aria-current", "true");
      var icon = createElement("span", "two-nu-compare__head-icon");
      icon.setAttribute("aria-hidden", "true");
      var label = createElement("span", "two-nu-compare__head-label", controller.fitOptionLabel(key));
      option.append(icon, label);
      options.appendChild(option);
    });
    wrapper.append(title, options);
    return wrapper;
  };

  ComparisonController.prototype.featureStateForItem = function (item) {
    var features = item && item.profile && item.profile.features ? item.profile.features : {};
    var familyKey = item && item.selection ? item.selection.lensFamilyKey : "";
    var material = cleanString(firstDefined(
      item && item.selection && item.selection.frameMaterialLabel,
      item && item.selection && item.selection.frameMaterialKey
    ), 160).toLowerCase();
    return {
      uv400: features.uv400 !== false,
      polarized: features.polarized === true || (
        features.polarized !== false && familyKey !== "tvo"
      ),
      hexachroma: features.hexachroma === true || familyKey === "hex" || familyKey === "hex_pre",
      metonic: features.metonic !== false,
      flexfoam: features.flexfoam === true || (
        features.flexfoam !== false && material.indexOf("flexfoam") !== -1
      ),
      float_max: features.floatMax === true,
      prescription: this.isPrescription(item)
    };
  };

  ComparisonController.prototype.createFeatureGrid = function (item) {
    var controller = this;
    var states = this.featureStateForItem(item);
    var grid = createElement("div", "two-nu-compare__feature-grid");
    grid.dataset.twoNuCompareFeatures = item.variantId;
    FEATURE_ORDER.forEach(function (key) {
      var available = states[key] === true;
      var label = controller.featureLabel(key);
      var status = controller.label(available ? "included" : "notIncluded");
      var cell = createElement("button", "two-nu-compare__feature two-nu-compare__feature--" + (available ? "yes" : "no"));
      cell.type = "button";
      cell.dataset.twoNuCompareFeatureInfo = key;
      cell.dataset.twoNuCompareFeatureAvailable = available ? "true" : "false";
      cell.setAttribute("aria-label", label + ": " + status);
      cell.setAttribute("aria-haspopup", "dialog");
      cell.appendChild(createElement("span", "two-nu-compare__feature-label", label));
      var icon = createElement("span", "two-nu-compare__feature-icon", available ? "✓" : "✕");
      icon.setAttribute("aria-hidden", "true");
      cell.appendChild(icon);
      grid.appendChild(cell);
    });
    return grid;
  };

  ComparisonController.prototype.createCoreDetails = function () {
    // Frame material remains in normalized data for feature truth, but is intentionally not repeated in the card UI.
    return null;
  };

  ComparisonController.prototype.variantUrl = function (item) {
    var candidate = item.canonicalUrl;
    var root = cleanString(firstDefined(
      this.root && this.root.dataset.rootUrl,
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root,
      "/"
    ), 240);
    if (root.charAt(root.length - 1) !== "/") root += "/";
    if (!candidate && item.productHandle) {
      candidate = root + "products/" + encodeURIComponent(item.productHandle);
    }
    try {
      var parsed = new URL(candidate, window.location.origin);
      if (parsed.origin === window.location.origin) {
        var productOffset = parsed.pathname.toLowerCase().lastIndexOf("/products/");
        if (productOffset !== -1) {
          var productPath = parsed.pathname.slice(productOffset);
          var rootPath = new URL(root, window.location.origin).pathname.replace(/\/$/, "");
          parsed.pathname = (rootPath === "/" ? "" : rootPath) + productPath;
          candidate = parsed.pathname + parsed.search + parsed.hash;
        }
      }
    } catch (error) {
      // withVariant() below retains the safest valid candidate.
    }
    return withVariant(candidate, item.variantId);
  };

  ComparisonController.prototype.accessibleItemLabel = function (item) {
    var exactVariant = this.variantLabel(item);
    var family = this.fieldMap(item).lensFamily;
    return [item.productTitle, exactVariant || family].filter(Boolean).join(" · ");
  };

  ComparisonController.prototype.galleryForItem = function (item) {
    var gallery = Array.isArray(item && item.gallery) ? item.gallery.filter(function (entry) {
      return entry && entry.url;
    }) : [];
    if (!gallery.length && item && item.image && item.image.url) gallery = [item.image];
    return gallery;
  };

  ComparisonController.prototype.applyGalleryImage = function (image, entry) {
    if (!image || !entry || !entry.url) return;
    if (entry.srcset) image.srcset = entry.srcset;
    else image.removeAttribute("srcset");
    image.src = entry.url;
    image.alt = entry.alt || this.label("productImage");
    image.dataset.twoNuCompareMediaType = entry.type || "image";
  };

  ComparisonController.prototype.applyLensSliderScene = function (slider, scene, item) {
    if (!slider || !scene) return;
    var before = slider.querySelector("[data-two-nu-compare-lens-before]");
    var after = slider.querySelector("[data-two-nu-compare-lens-after]");
    var label = slider.querySelector("[data-two-nu-compare-lens-label]");
    var range = slider.querySelector("[data-two-nu-compare-lens-range]");
    this.applyGalleryImage(before, Object.assign({}, scene.before, { type: "lens_slider_before" }));
    this.applyGalleryImage(after, Object.assign({}, scene.after, { type: "lens_slider_after" }));
    if (label) {
      label.textContent = scene.afterLabel ||
        cleanString(item && item.selection && item.selection.lensFamilyLabel, 80) ||
        this.label("productImage");
    }
    if (range) {
      range.setAttribute(
        "aria-label",
        "Compare naked-eye and " +
          (scene.afterLabel || cleanString(item && item.selection && item.selection.lensFamilyLabel, 80) || "lens") +
          " view"
      );
    }
    slider.dataset.twoNuCompareActiveLensScene = scene.key;
    slider.querySelectorAll("[data-two-nu-compare-lens-scene]").forEach(function (button) {
      var isActive = button.dataset.twoNuCompareLensScene === scene.key;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  };

  ComparisonController.prototype.createLensSlider = function (entry, item) {
    var lensSlider = entry && entry.lensSlider;
    if (!lensSlider || !Array.isArray(lensSlider.scenes) || !lensSlider.scenes.length) return null;
    var controller = this;
    var slider = createElement("div", "two-nu-compare__lens-slider");
    slider.dataset.twoNuCompareLensSlider = item.variantId;
    slider.style.setProperty("--two-nu-compare-lens-pos", "50%");

    var stage = createElement("div", "two-nu-compare__lens-slider-stage");
    stage.dataset.twoNuCompareLensStage = "";
    var after = createElement("img", "two-nu-compare__lens-slider-image two-nu-compare__lens-slider-image--after");
    after.dataset.twoNuCompareLensAfter = "";
    after.loading = "lazy";
    after.decoding = "async";
    after.width = 720;
    after.height = 720;
    var before = createElement("img", "two-nu-compare__lens-slider-image two-nu-compare__lens-slider-image--before");
    before.dataset.twoNuCompareLensBefore = "";
    before.loading = "lazy";
    before.decoding = "async";
    before.width = 720;
    before.height = 720;

    var divider = createElement("span", "two-nu-compare__lens-slider-divider");
    divider.setAttribute("aria-hidden", "true");
    var handle = createElement("span", "two-nu-compare__lens-slider-handle");
    handle.setAttribute("aria-hidden", "true");
    divider.appendChild(handle);

    var range = createElement("input", "two-nu-compare__lens-slider-range");
    range.type = "range";
    range.min = "8";
    range.max = "92";
    range.step = "1";
    range.value = "50";
    range.dataset.twoNuCompareLensRange = "";
    range.addEventListener("input", function () {
      slider.style.setProperty("--two-nu-compare-lens-pos", range.value + "%");
    });
    range.addEventListener("click", function (event) {
      event.stopPropagation();
    });

    var label = createElement("span", "two-nu-compare__lens-slider-label");
    label.dataset.twoNuCompareLensLabel = "";

    var scenes = createElement("div", "two-nu-compare__lens-slider-scenes");
    scenes.setAttribute("aria-label", "Lens scenes");
    lensSlider.scenes.forEach(function (scene) {
      var button = createElement("button", "two-nu-compare__lens-slider-scene");
      button.type = "button";
      button.dataset.twoNuCompareLensScene = scene.key;
      button.setAttribute("aria-label", scene.label || humanize(scene.key));
      button.setAttribute("aria-pressed", "false");
      if (scene.thumbnailUrl) {
        var thumbnail = createElement("img", "two-nu-compare__lens-slider-scene-image");
        thumbnail.src = scene.thumbnailUrl;
        thumbnail.alt = "";
        thumbnail.loading = "lazy";
        thumbnail.decoding = "async";
        button.appendChild(thumbnail);
      } else {
        button.textContent = cleanString(scene.label || humanize(scene.key), 2);
      }
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        controller.applyLensSliderScene(slider, scene, item);
      });
      scenes.appendChild(button);
    });

    stage.append(after, before, divider, range, scenes, label);
    slider.appendChild(stage);
    var initialScene = lensSlider.scenes.find(function (scene) {
      return scene.key === lensSlider.defaultScene;
    }) || lensSlider.scenes[0];
    this.applyLensSliderScene(slider, initialScene, item);
    return slider;
  };

  ComparisonController.prototype.applyGalleryEntry = function (media, image, entry, item) {
    if (!media || !image || !entry) return;
    var existingSlider = media.querySelector("[data-two-nu-compare-lens-slider]");
    var hasUsableSlider = entry.type === "lens_slider" &&
      entry.lensSlider &&
      Array.isArray(entry.lensSlider.scenes) &&
      entry.lensSlider.scenes.length > 0;
    media.dataset.twoNuCompareActiveMediaType = hasUsableSlider ? "lens_slider" : (entry.type || "image");
    if (!hasUsableSlider) {
      if (existingSlider) existingSlider.remove();
      image.hidden = false;
      image.removeAttribute("aria-hidden");
      this.applyGalleryImage(image, entry);
      return;
    }
    image.hidden = true;
    image.setAttribute("aria-hidden", "true");
    if (existingSlider) existingSlider.remove();
    var slider = this.createLensSlider(entry, item);
    if (slider) media.insertBefore(slider, image.nextSibling);
  };

  ComparisonController.prototype.updateGalleryControl = function (button, gallery, currentIndex, item) {
    if (!button || gallery.length < 2) return;
    var nextIndex = (currentIndex + 1) % gallery.length;
    var preview = button.querySelector("[data-two-nu-compare-gallery-preview]");
    var counter = button.querySelector("[data-two-nu-compare-gallery-counter]");
    this.applyGalleryImage(preview, Object.assign({}, gallery[nextIndex], {
      url: gallery[nextIndex].thumbnailUrl || gallery[nextIndex].url
    }));
    button.dataset.twoNuCompareGalleryIndex = String(currentIndex);
    button.setAttribute(
      "aria-label",
      this.label("productImage") + " " + (nextIndex + 1) + " / " + gallery.length + ": " + this.accessibleItemLabel(item)
    );
    if (counter) counter.textContent = (nextIndex + 1) + "/" + gallery.length;
  };

  ComparisonController.prototype.createMediaGallery = function (item) {
    var media = createElement("div", "two-nu-compare__card-media two-nu-compare__media");
    var gallery = this.galleryForItem(item);
    if (!gallery.length) return media;

    var image = createElement("img", "two-nu-compare__card-image");
    image.loading = "lazy";
    image.decoding = "async";
    image.width = 720;
    image.height = 720;
    image.dataset.twoNuCompareGalleryImage = item.variantId;
    image.dataset.twoNuCompareGalleryIndex = "0";
    media.appendChild(image);
    this.applyGalleryEntry(media, image, gallery[0], item);

    if (gallery.length > 1) {
      var pip = createElement("button", "two-nu-compare__pip");
      pip.type = "button";
      pip.dataset.twoNuCompareGalleryNext = item.variantId;
      var preview = createElement("img", "two-nu-compare__pip-image");
      preview.dataset.twoNuCompareGalleryPreview = "";
      preview.loading = "lazy";
      preview.decoding = "async";
      preview.width = 112;
      preview.height = 112;
      var counter = createElement("span", "two-nu-compare__pip-counter");
      counter.dataset.twoNuCompareGalleryCounter = "";
      pip.append(preview, counter);
      media.appendChild(pip);
      this.updateGalleryControl(pip, gallery, 0, item);
    }
    return media;
  };

  ComparisonController.prototype.cycleGallery = function (button) {
    var id = cleanId(button && button.dataset.twoNuCompareGalleryNext);
    var item = this.items.find(function (entry) { return entry.variantId === id; });
    var card = button && button.closest("[data-two-nu-compare-card-index]");
    var image = card && card.querySelector("[data-two-nu-compare-gallery-image]");
    if (!item || !card || !image) return;
    var gallery = this.galleryForItem(item);
    if (gallery.length < 2) return;
    var currentIndex = Number(button.dataset.twoNuCompareGalleryIndex);
    if (!Number.isFinite(currentIndex) || currentIndex < 0) currentIndex = 0;
    var nextIndex = (currentIndex + 1) % gallery.length;
    this.applyGalleryEntry(card.querySelector(".two-nu-compare__card-media"), image, gallery[nextIndex], item);
    image.dataset.twoNuCompareGalleryIndex = String(nextIndex);
    this.updateGalleryControl(button, gallery, nextIndex, item);
  };

  ComparisonController.prototype.galleryEndpoint = function (item) {
    var url = this.variantUrl(item);
    if (!url) return "";
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.search = "";
      parsed.hash = "";
      parsed.searchParams.set("view", "callout-pip-json");
      return parsed.origin === window.location.origin
        ? parsed.pathname + parsed.search
        : "";
    } catch (error) {
      return "";
    }
  };

  ComparisonController.prototype.fetchGalleryPayload = function (item) {
    var url = this.galleryEndpoint(item);
    if (!url) return Promise.resolve(null);
    var shared = window.__twoNuShopAllPipLazyVariantCache;
    var cache = shared instanceof Map ? shared : this.galleryRequests;
    if (!cache.has(url)) {
      cache.set(url, fetch(url, {
        credentials: "same-origin",
        headers: { Accept: "application/json,text/plain,*/*" }
      }).then(function (response) {
        if (!response.ok) throw new Error("Comparison gallery request failed: " + response.status);
        return response.json();
      }).catch(function (error) {
        cache.delete(url);
        throw error;
      }));
    }
    return Promise.resolve(cache.get(url));
  };

  ComparisonController.prototype.galleryFromPayload = function (item, payload) {
    var records = payload && payload.variants && payload.variants[item.variantId];
    if (!Array.isArray(records)) return this.galleryForItem(item);
    var extras = records.map(function (record) {
      var main = isObject(record && record.main) ? record.main : {};
      var pip = isObject(record && record.pip) ? record.pip : {};
      var type = slug(record && record.type) || "image";
      var lensSlider = type === "lens_slider"
        ? normalizeLensSlider(record, item.productTitle)
        : null;
      var defaultScene = lensSlider && lensSlider.scenes.find(function (scene) {
        return scene.key === lensSlider.defaultScene;
      });
      return {
        url: firstDefined(main.src, defaultScene && defaultScene.after.url),
        thumbnailUrl: firstDefined(
          pip.src,
          defaultScene && defaultScene.thumbnailUrl,
          main.src,
          defaultScene && defaultScene.after.url
        ),
        srcset: firstDefined(main.srcset, defaultScene && defaultScene.after.srcset),
        alt: firstDefined(main.alt, pip.alt, defaultScene && defaultScene.after.alt, item.productTitle),
        type: type,
        lensSlider: lensSlider
      };
    });
    return normalizeGallery(extras, item.image, item.productTitle);
  };

  ComparisonController.prototype.syncMediaGallery = function (item) {
    if (!this.root || !item) return;
    var escapedId = window.CSS && typeof window.CSS.escape === "function"
      ? window.CSS.escape(item.variantId)
      : item.variantId;
    var card = this.root.querySelector("[data-variant-id='" + escapedId + "']");
    var media = card && card.querySelector(".two-nu-compare__card-media");
    if (!card || !media) return;
    var gallery = this.galleryForItem(item);
    if (!gallery.length) return;
    var image = media.querySelector("[data-two-nu-compare-gallery-image]");
    if (!image) {
      image = createElement("img", "two-nu-compare__card-image");
      image.dataset.twoNuCompareGalleryImage = item.variantId;
      image.loading = "lazy";
      image.decoding = "async";
      image.width = 720;
      image.height = 720;
      media.prepend(image);
    }
    var pip = media.querySelector("[data-two-nu-compare-gallery-next]");
    var currentIndex = Number(image.dataset.twoNuCompareGalleryIndex);
    if (!Number.isFinite(currentIndex) || currentIndex < 0 || currentIndex >= gallery.length) currentIndex = 0;
    image.dataset.twoNuCompareGalleryIndex = String(currentIndex);
    this.applyGalleryEntry(media, image, gallery[currentIndex], item);
    if (gallery.length < 2) {
      if (pip) pip.remove();
      return;
    }
    if (!pip) {
      pip = createElement("button", "two-nu-compare__pip");
      pip.type = "button";
      pip.dataset.twoNuCompareGalleryNext = item.variantId;
      var preview = createElement("img", "two-nu-compare__pip-image");
      preview.dataset.twoNuCompareGalleryPreview = "";
      preview.loading = "lazy";
      preview.decoding = "async";
      preview.width = 112;
      preview.height = 112;
      var counter = createElement("span", "two-nu-compare__pip-counter");
      counter.dataset.twoNuCompareGalleryCounter = "";
      pip.append(preview, counter);
      media.appendChild(pip);
    }
    this.updateGalleryControl(pip, gallery, currentIndex, item);
  };

  ComparisonController.prototype.galleryNeedsHydration = function (item) {
    var gallery = this.galleryForItem(item);
    if (gallery.length < 2) return true;
    return gallery.some(function (entry) {
      return entry &&
        entry.type === "lens_slider" &&
        (!entry.lensSlider ||
          !Array.isArray(entry.lensSlider.scenes) ||
          !entry.lensSlider.scenes.length);
    });
  };

  ComparisonController.prototype.hydrateGalleries = function () {
    var controller = this;
    this.items.forEach(function (item) {
      if (!controller.galleryNeedsHydration(item)) {
        controller.syncMediaGallery(item);
        return;
      }
      controller.fetchGalleryPayload(item).then(function (payload) {
        var current = controller.items.find(function (entry) { return entry.variantId === item.variantId; });
        if (!current) return;
        var gallery = controller.galleryFromPayload(current, payload);
        if (gallery.length < 2) return;
        current.gallery = gallery;
        controller.persist(false);
        controller.syncMediaGallery(current);
      }).catch(function () {
        // The exact hero remains usable when optional PIP media is unavailable.
      });
    });
  };

  ComparisonController.prototype.purchaseState = function (item) {
    var status = this.runtimeStatus.get(item.variantId);
    if (item.commerce.available === false || status === "sold-out") return "sold-out";
    if (status === "unavailable" || status === "unresolved" || item.commerce.available !== true) return "unavailable";
    if (this.pendingCartIds.has(item.variantId)) return "pending";
    return "ready";
  };

  ComparisonController.prototype.canUsePurchase = function (item) {
    if (this.purchaseState(item) !== "ready") return false;
    if (this.isPrescription(item)) return Boolean(this.variantUrl(item));
    return true;
  };

  ComparisonController.prototype.createActions = function (item) {
    var actions = createElement("div", "two-nu-compare__card-actions");
    var prescription = this.isPrescription(item);
    var accessibleItem = this.accessibleItemLabel(item);
    var purchaseState = this.purchaseState(item);
    var purchaseLabel = prescription ? this.label("orderNow") : this.label("addToCart");
    if (purchaseState === "sold-out") purchaseLabel = this.label("soldOut");
    else if (purchaseState === "unavailable") purchaseLabel = this.label("unavailable");
    else if (purchaseState === "pending") purchaseLabel = this.label("addingToCart");
    var purchase = createElement(
      "button",
      "two-nu-compare__purchase",
      purchaseLabel
    );
    purchase.type = "button";
    purchase.dataset.twoNuCompareCart = item.variantId;
    purchase.dataset.twoNuComparePurchaseState = purchaseState;
    purchase.setAttribute("aria-label", purchase.textContent + ": " + accessibleItem);
    purchase.disabled = !this.canUsePurchase(item);
    if (purchaseState === "pending") {
      purchase.setAttribute("aria-busy", "true");
    }
    actions.appendChild(purchase);

    if (item.profile.aiTryOn.available === true) {
      var ai = createElement("button", "two-nu-compare__ai-tryon", this.label("aiTryOn"));
      ai.type = "button";
      ai.dataset.twoNuCompareAiTryon = item.variantId;
      ai.setAttribute("aria-label", this.label("aiTryOn") + ": " + accessibleItem);
      actions.appendChild(ai);
    }
    var exactUrl = this.variantUrl(item);
    if (exactUrl) {
      var link = createElement("a", "two-nu-compare__variant-link", this.label("viewVariant"));
      link.href = exactUrl;
      link.dataset.twoNuCompareVariantLink = item.variantId;
      link.setAttribute("aria-label", this.label("viewVariant") + ": " + accessibleItem);
      actions.appendChild(link);
    }
    return actions;
  };

  ComparisonController.prototype.createCardRadar = function (item, index) {
    var radar = createElement("div", "two-nu-compare__card-radar");
    radar.dataset.twoNuCompareCardRadar = item.variantId;
    var canvas = createElement("canvas", "two-nu-compare__card-radar-canvas");
    canvas.dataset.twoNuCompareCardCanvas = item.variantId;
    canvas.dataset.twoNuCompareRadarIndex = String(index);
    canvas.setAttribute("role", "img");
    radar.appendChild(canvas);
    return radar;
  };

  ComparisonController.prototype.createCard = function (item, index) {
    var status = this.runtimeStatus.get(item.variantId) || "unknown";
    var commerceCurrent = this.commerceIsCurrent(item);
    var card = createElement("article", "two-nu-compare__card");
    card.dataset.twoNuCompareCardIndex = String(index);
    card.dataset.variantId = item.variantId;
    var cardSeries = SERIES[index] || SERIES[0];
    card.style.setProperty("--two-nu-compare-active-color", cardSeries.color);
    card.style.setProperty("--two-nu-compare-active-shadow", cardSeries.shadow);
    card.tabIndex = 0;
    card.setAttribute("aria-label", this.accessibleItemLabel(item));

    var remove = createElement("button", "two-nu-compare__card-remove two-nu-compare__remove", "×");
    remove.type = "button";
    remove.dataset.twoNuCompareRemove = item.variantId;
    remove.setAttribute("aria-label", this.label("remove") + ": " + this.accessibleItemLabel(item));
    card.appendChild(remove);

    card.appendChild(this.createMediaGallery(item));

    var content = createElement("div", "two-nu-compare__card-content");
    var titleRow = createElement("div", "two-nu-compare__card-title-row");
    titleRow.appendChild(createElement(
      "h3",
      "two-nu-compare__card-title two-nu-compare__product-title",
      item.productTitle || this.label("viewVariant")
    ));
    var sku = createElement("span", "two-nu-compare__card-sku", item.sku);
    sku.dataset.twoNuCompareSku = item.variantId;
    sku.hidden = !item.sku;
    if (item.sku) sku.setAttribute("aria-label", "SKU " + item.sku);
    titleRow.appendChild(sku);
    content.appendChild(titleRow);

    var commerce = createElement("div", "two-nu-compare__card-commerce");
    var price = createElement("div", "two-nu-compare__card-price");
    var currency = this.currentCurrency(item);
    if (commerceCurrent) {
      if (item.commerce.compareAtPrice !== null && item.commerce.price !== null && item.commerce.compareAtPrice > item.commerce.price) {
        price.appendChild(createElement("del", "", this.formatMoney(item.commerce.compareAtPrice, currency)));
        price.appendChild(document.createTextNode(" "));
      }
      price.appendChild(createElement("span", "", this.formatMoney(item.commerce.price, currency)));
    } else {
      price.hidden = true;
    }
    commerce.appendChild(price);
    var availability = createElement(
      "span",
      "two-nu-compare__card-availability two-nu-compare__availability",
      this.availabilityLabel(item)
    );
    var availabilityState = status;
    if (availabilityState === "unknown") {
      availabilityState = item.commerce.available === true
        ? "fresh"
        : (item.commerce.available === false ? "sold-out" : "unavailable");
    }
    availability.dataset.state = availabilityState === "refresh-failed"
      ? "error"
      : (availabilityState === "unresolved" ? "unavailable" : availabilityState);
    if (commerceCurrent) availability.dataset.available = item.commerce.available === true ? "true" : "false";
    commerce.appendChild(availability);
    content.appendChild(commerce);

    var desktopBody = createElement("div", "two-nu-compare__card-desktop-body");
    var fit = this.createHeadFit(item);
    if (fit) desktopBody.appendChild(fit);
    desktopBody.appendChild(this.createFeatureGrid(item));
    var coreDetails = this.createCoreDetails(item);
    if (coreDetails) desktopBody.appendChild(coreDetails);
    desktopBody.appendChild(this.createActions(item));
    desktopBody.appendChild(this.createCardRadar(item, index));
    content.appendChild(desktopBody);
    card.appendChild(content);
    return card;
  };

  ComparisonController.prototype.renderMobileDetails = function () {
    if (!this.elements.mobileDetails) return;
    this.elements.mobileDetails.replaceChildren();
    this.elements.mobileDetails.hidden = true;
  };

  ComparisonController.prototype.renderReplacement = function () {
    if (!this.elements.replacement || !this.pendingReplacement) return;
    var controller = this;
    var replacement = this.elements.replacement;
    replacement.replaceChildren();
    var intro = createElement("div", "two-nu-compare__replacement-intro");
    intro.appendChild(createElement("h3", "two-nu-compare__replacement-title", this.label("fullTitle")));
    intro.appendChild(createElement("p", "two-nu-compare__replacement-copy", this.label("fullCopy")));
    var pending = createElement(
      "p",
      "two-nu-compare__replacement-pending",
      this.pendingReplacement.productTitle + (
        this.fieldMap(this.pendingReplacement).lensFamily
          ? " · " + this.fieldMap(this.pendingReplacement).lensFamily
          : ""
      )
    );
    intro.appendChild(pending);
    replacement.appendChild(intro);
    var choices = createElement(
      "div",
      "two-nu-compare__replacement-choices two-nu-compare__replacement-list"
    );
    this.items.forEach(function (item) {
      var button = createElement(
        "button",
        "two-nu-compare__replacement-choice two-nu-compare__replacement-option"
      );
      button.type = "button";
      button.dataset.twoNuCompareReplaceId = item.variantId;
      button.dataset.twoNuCompareReplace = "";
      button.setAttribute(
        "aria-label",
        controller.label("replaceThis") + ": " + controller.accessibleItemLabel(item)
      );
      if (item.image.url) {
        var image = createElement("img", "two-nu-compare__replacement-image");
        image.src = item.image.url;
        image.alt = "";
        image.loading = "lazy";
        image.width = 92;
        image.height = 92;
        button.appendChild(image);
      }
      button.appendChild(createElement(
        "span",
        "two-nu-compare__replacement-label",
        controller.label("replaceThis") + ": " + item.productTitle + (
          controller.fieldMap(item).lensFamily
            ? " · " + controller.fieldMap(item).lensFamily
            : ""
        )
      ));
      choices.appendChild(button);
    });
    replacement.appendChild(choices);
    var cancel = createElement("button", "two-nu-compare__replacement-cancel", this.label("cancel"));
    cancel.type = "button";
    cancel.dataset.twoNuCompareReplacementCancel = "";
    replacement.appendChild(cancel);
  };

  ComparisonController.prototype.renderLegend = function () {
    if (!this.elements.legend) return;
    var controller = this;
    this.elements.legend.replaceChildren();
    this.items.forEach(function (item, index) {
      var button = createElement("button", "two-nu-compare__legend-item");
      button.type = "button";
      button.dataset.twoNuCompareLegendIndex = String(index);
      button.style.setProperty("--two-nu-compare-series-color", SERIES[index].color);
      button.setAttribute("aria-label", controller.accessibleItemLabel(item));
      var swatch = createElement("span", "two-nu-compare__legend-swatch");
      swatch.setAttribute("aria-hidden", "true");
      var family = controller.fieldMap(item).lensFamily;
      var label = createElement(
        "span",
        "two-nu-compare__legend-label",
        item.productTitle + (family ? " · " + family : "")
      );
      button.append(swatch, label);
      controller.elements.legend.appendChild(button);
    });
  };

  ComparisonController.prototype.updateActiveVisuals = function () {
    if (!this.root) return;
    var index = this.activeIndex;
    this.root.querySelectorAll("[data-two-nu-compare-card-index]").forEach(function (card) {
      var active = Number(card.dataset.twoNuCompareCardIndex) === index;
      card.classList.toggle("is-active", active);
      if (active) card.setAttribute("aria-current", "true");
      else card.removeAttribute("aria-current");
    });
    this.root.querySelectorAll("[data-two-nu-compare-legend-index]").forEach(function (legend) {
      var active = Number(legend.dataset.twoNuCompareLegendIndex) === index;
      legend.classList.toggle("is-active", active);
      legend.setAttribute("aria-pressed", active ? "true" : "false");
    });
    if (this.elements.previous) this.elements.previous.disabled = index <= 0;
    if (this.elements.next) this.elements.next.disabled = index >= this.items.length - 1;
  };

  ComparisonController.prototype.alignTrackToActive = function (behavior) {
    if (!this.elements.cards || !window.matchMedia("(max-width: 749px)").matches) return;
    var card = this.elements.cards.querySelector(
      "[data-two-nu-compare-card-index='" + this.activeIndex + "']"
    );
    if (!card) return;
    var maximum = Math.max(0, this.elements.cards.scrollWidth - this.elements.cards.clientWidth);
    var scrollPaddingStart = parseFloat(window.getComputedStyle(this.elements.cards).scrollPaddingLeft) || 0;
    var targetLeft = Math.max(0, Math.min(card.offsetLeft - scrollPaddingStart, maximum));
    var scrollBehavior = behavior === "smooth" ? "smooth" : "auto";
    if (scrollBehavior === "smooth") {
        window.clearTimeout(this.scrollTargetTimer);
        this.scrollTargetIndex = this.activeIndex;
        this.scrollTargetTimer = window.setTimeout(function (controller) {
          controller.scrollTargetIndex = null;
        }, 1000, this);
    } else {
      window.clearTimeout(this.scrollTargetTimer);
      this.scrollTargetIndex = null;
    }
    this.elements.cards.scrollTo({ left: targetLeft, behavior: scrollBehavior });
  };

  ComparisonController.prototype.setActiveIndex = function (nextIndex, shouldScroll) {
    if (!this.items.length) return;
    this.activeIndex = Math.max(0, Math.min(Number(nextIndex) || 0, this.items.length - 1));
    this.updateActiveVisuals();
    if (shouldScroll) {
      var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      this.alignTrackToActive(reduceMotion ? "auto" : "smooth");
    }
  };

  ComparisonController.prototype.onCardsScroll = function () {
    var controller = this;
    window.cancelAnimationFrame(this.scrollFrame);
    this.scrollFrame = window.requestAnimationFrame(function () {
      if (!controller.elements.cards) return;
      if (controller.scrollTargetIndex !== null) return;
      var cards = Array.from(controller.elements.cards.querySelectorAll("[data-two-nu-compare-card-index]"));
      if (!cards.length) return;
      var rect = controller.elements.cards.getBoundingClientRect();
      var center = rect.left + rect.width / 2;
      var closest = cards.reduce(function (best, card) {
        var cardRect = card.getBoundingClientRect();
        var distance = Math.abs(cardRect.left + cardRect.width / 2 - center);
        return !best || distance < best.distance
          ? { index: Number(card.dataset.twoNuCompareCardIndex), distance: distance }
          : best;
      }, null);
      if (closest && closest.index !== controller.activeIndex) {
        controller.activeIndex = closest.index;
        controller.updateActiveVisuals();
      }
    });
  };

  ComparisonController.prototype.onCardsScrollEnd = function () {
    window.clearTimeout(this.scrollTargetTimer);
    this.scrollTargetIndex = null;
    this.onCardsScroll();
  };

  ComparisonController.prototype.onCardsPointerDown = function () {
    if (!this.elements.cards || this.scrollTargetIndex === null) return;
    window.clearTimeout(this.scrollTargetTimer);
    this.scrollTargetIndex = null;
    this.elements.cards.scrollTo({
      left: this.elements.cards.scrollLeft,
      behavior: "auto"
    });
  };

  ComparisonController.prototype.seriesHasScores = function (item) {
    return AXES.some(function (axis) {
      return numberOrNull(item.profile.activityScores[axis]) !== null;
    });
  };

  ComparisonController.prototype.drawRadarCanvas = function (canvas, drawable, activeIndex, singleSeries) {
    if (!canvas || !drawable.length) return;
    var controller = this;
    var rect = canvas.getBoundingClientRect();
    var compact = canvas.hasAttribute("data-two-nu-compare-card-canvas");
    var minimum = compact ? 124 : (singleSeries ? 124 : 220);
    var compactMaximum = window.matchMedia("(max-width: 749px)").matches ? 310 : 220;
    var maximum = compact ? compactMaximum : (singleSeries ? 210 : 340);
    var size = Math.max(minimum, Math.min(Math.round(rect.width || maximum), maximum));
    var dpr = Math.max(1, window.devicePixelRatio || 1);
    canvas.width = Math.round(size * dpr);
    canvas.height = Math.round(size * dpr);
    canvas.style.height = size + "px";
    var context = canvas.getContext("2d");
    if (!context) return;
    context.setTransform(dpr, 0, 0, dpr, 0, 0);
    context.clearRect(0, 0, size, size);

    var center = size / 2;
    var radius = size * 0.292;
    var outerPlateRadius = size * 0.43;
    var labelRadius = size * 0.392;
    function point(index, score, customRadius) {
      var angle = -Math.PI / 2 + Math.PI * 2 * index / AXES.length;
      var baseRadius = customRadius === undefined ? radius : customRadius;
      var scaledRadius = score === null ? baseRadius : baseRadius * score / 5;
      return {
        x: center + Math.cos(angle) * scaledRadius,
        y: center + Math.sin(angle) * scaledRadius
      };
    }
    function polygon(points) {
      context.beginPath();
      points.forEach(function (entry, index) {
        if (index === 0) context.moveTo(entry.x, entry.y);
        else context.lineTo(entry.x, entry.y);
      });
      context.closePath();
    }
    function colorWithAlpha(hex, alpha) {
      var value = String(hex || "#0BF477").replace("#", "");
      var number = parseInt(value.length === 3
        ? value.split("").map(function (part) { return part + part; }).join("")
        : value, 16);
      return "rgba(" + ((number >> 16) & 255) + "," + ((number >> 8) & 255) + "," + (number & 255) + "," + alpha + ")";
    }
    var basePoints = AXES.map(function (axis, index) { return point(index, 5, radius); });
    var outerPoints = AXES.map(function (axis, index) { return point(index, 5, outerPlateRadius); });
    context.save();
    polygon(outerPoints);
    context.shadowColor = "rgba(0, 68, 73, .14)";
    context.shadowBlur = Math.max(3, size * .032);
    context.shadowOffsetY = Math.max(1, size * .012);
    var plateGradient = context.createRadialGradient(center, center, size * .08, center, center, outerPlateRadius);
    plateGradient.addColorStop(0, "rgba(247, 249, 248, .34)");
    plateGradient.addColorStop(.58, "rgba(226, 233, 230, .58)");
    plateGradient.addColorStop(1, "rgba(202, 213, 209, .74)");
    context.fillStyle = plateGradient;
    context.fill();
    context.restore();

    context.save();
    context.lineWidth = Math.max(1, size * .006);
    outerPoints.forEach(function (entry, index) {
      var next = outerPoints[(index + 1) % outerPoints.length];
      context.beginPath();
      context.moveTo(entry.x, entry.y);
      context.lineTo(entry.x * .18 + next.x * .82, entry.y * .18 + next.y * .82);
      context.strokeStyle = "rgba(255, 255, 255, .18)";
      context.stroke();
    });
    context.restore();

    context.save();
    polygon(basePoints);
    var coreGradient = context.createRadialGradient(center, center, radius * .04, center, center, radius);
    coreGradient.addColorStop(0, "rgba(0, 68, 73, .34)");
    coreGradient.addColorStop(1, "rgba(0, 68, 73, .06)");
    context.fillStyle = coreGradient;
    context.fill();
    [1, 2, 3, 4, 5].forEach(function (level) {
      var ringPoints = AXES.map(function (axis, index) { return point(index, level, radius); });
      polygon(ringPoints);
      context.lineWidth = level === 5 ? Math.max(1.2, size * .011) : Math.max(.7, size * .0055);
      context.strokeStyle = level === 5 ? "rgba(0, 68, 73, .30)" : "rgba(0, 68, 73, .13)";
      context.stroke();
    });
    basePoints.forEach(function (entry) {
      context.beginPath();
      context.moveTo(center, center);
      context.lineTo(entry.x, entry.y);
      context.lineWidth = Math.max(.7, size * .0055);
      context.strokeStyle = "rgba(0, 68, 73, .14)";
      context.stroke();
    });
    context.restore();

    var ordered = drawable.slice().sort(function (a, b) {
      if (a.index === activeIndex) return 1;
      if (b.index === activeIndex) return -1;
      return a.index - b.index;
    });
    ordered.forEach(function (series) {
      var color = singleSeries ? "#0BF477" : (SERIES[series.index] || SERIES[0]).color;
      var isActive = singleSeries || series.index === activeIndex;
      var values = AXES.map(function (axis) {
        return numberOrNull(series.item.profile.activityScores[axis]);
      });
      var points = values.map(function (value, index) {
        return value === null ? null : point(index, value, radius);
      });
      var allKnown = points.every(Boolean);
      context.save();
      context.lineJoin = "round";
      context.strokeStyle = color;
      context.lineWidth = singleSeries
        ? Math.max(2, size * .017)
        : (isActive ? Math.max(3.6, size * .019) : Math.max(1.6, size * .0085));
      context.globalAlpha = 1;
      if (allKnown) {
        polygon(points);
        if (singleSeries) {
          var scoreGradient = context.createRadialGradient(center, center, 0, center, center, radius);
          scoreGradient.addColorStop(0, "rgba(0, 68, 73, .86)");
          scoreGradient.addColorStop(.52, "rgba(0, 102, 91, .78)");
          scoreGradient.addColorStop(1, "rgba(11, 244, 119, .66)");
          context.fillStyle = scoreGradient;
          context.fill();
        } else {
          context.fillStyle = colorWithAlpha(color, .035);
          context.fill();
        }
        context.stroke();
      } else {
        points.forEach(function (entry, index) {
          var next = points[(index + 1) % points.length];
          if (!entry || !next) return;
          context.beginPath();
          context.moveTo(entry.x, entry.y);
          context.lineTo(next.x, next.y);
          context.stroke();
        });
      }
      context.shadowBlur = 0;
      points.forEach(function (entry) {
        if (!entry) return;
        var markerSize = singleSeries ? Math.max(2, size * .017) : Math.max(2.4, size * .009);
        context.beginPath();
        context.arc(entry.x, entry.y, markerSize, 0, Math.PI * 2);
        context.fillStyle = "rgba(247, 250, 249, .96)";
        context.fill();
        context.lineWidth = Math.max(1.15, size * .0065);
        context.strokeStyle = color;
        context.stroke();
      });
      context.restore();
    });

    context.beginPath();
    context.arc(center, center, Math.max(2, size * .018), 0, Math.PI * 2);
    context.fillStyle = singleSeries ? "#0BF477" : "#004449";
    context.fill();
    if (singleSeries) {
      context.beginPath();
      context.arc(center, center, Math.max(6, size * .05), 0, Math.PI * 2);
      context.strokeStyle = "rgba(11, 244, 119, .24)";
      context.lineWidth = Math.max(1, size * .008);
      context.stroke();
    }

    var activeSeries = drawable.find(function (series) { return series.index === activeIndex; }) || drawable[0];
    var labelFontSize = Math.max(7, Math.min(10.2, size * .058));
    var maxLabelWidth = size * .34;
    var radarFontFamily = window.getComputedStyle(canvas).fontFamily || "Montserrat, Helvetica Neue, Arial, sans-serif";
    context.textBaseline = "middle";
    AXES.forEach(function (axis, index) {
      var angle = -Math.PI / 2 + Math.PI * 2 * index / AXES.length;
      var labelPoint = point(index, 5, labelRadius);
      var activeScore = activeSeries ? numberOrNull(activeSeries.item.profile.activityScores[axis]) : null;
      var highlight = activeScore !== null && activeScore >= 4.95;
      var text = String(controller.axisLabel(axis) || "").toLocaleUpperCase();
      context.font = (highlight ? "700 " : "600 ") + labelFontSize + "px " + radarFontFamily;
      var measuredWidth = Math.min(maxLabelWidth, context.measureText(text).width || maxLabelWidth);
      var rotation = angle + Math.PI / 2;
      rotation = Math.atan2(Math.sin(rotation), Math.cos(rotation));
      if (rotation > Math.PI / 2) rotation -= Math.PI;
      if (rotation < -Math.PI / 2) rotation += Math.PI;
      context.save();
      context.translate(labelPoint.x, labelPoint.y);
      context.rotate(rotation);
      context.textAlign = "center";
      if (highlight) {
        var highlightWidth = Math.min(maxLabelWidth + size * .025, measuredWidth + size * .09);
        var highlightHeight = labelFontSize * 1.42;
        context.fillStyle = "rgba(11, 244, 119, .34)";
        context.beginPath();
        if (typeof context.roundRect === "function") {
          context.roundRect(-highlightWidth / 2, -highlightHeight / 2, highlightWidth, highlightHeight, highlightHeight / 2);
        } else {
          context.rect(-highlightWidth / 2, -highlightHeight / 2, highlightWidth, highlightHeight);
        }
        context.fill();
      }
      context.fillStyle = "#004449";
      var guideLength = Math.min(maxLabelWidth, measuredWidth + size * .045);
      context.beginPath();
      context.moveTo(-guideLength / 2, labelFontSize * .72);
      context.lineTo(guideLength / 2, labelFontSize * .72);
      context.lineWidth = Math.max(.7, size * .0045);
      context.strokeStyle = "rgba(0, 68, 73, .22)";
      context.stroke();
      context.fillText(text, 0, 0, maxLabelWidth);
      context.restore();
    });

    var summary = drawable.map(function (series) {
      return series.item.productTitle + ": " + AXES.map(function (axis) {
        var value = series.item.profile.activityScores[axis];
        return controller.axisLabel(axis) + " " + (value === null ? controller.label("notRated") : value + " / 5");
      }).join(", ");
    }).join(". ");
    canvas.setAttribute("aria-label", summary);
    canvas.dataset.twoNuCompareSeriesCount = String(drawable.length);
    canvas.dataset.twoNuCompareSeriesColors = drawable.map(function (series) {
      return singleSeries ? "#0BF477" : (SERIES[series.index] || SERIES[0]).color;
    }).join(",");
    canvas.dataset.twoNuCompareActiveSeries = String(singleSeries ? 0 : activeIndex);
    canvas.dataset.twoNuCompareDrawOrder = ordered.map(function (series) { return series.index; }).join(",");
    canvas.dataset.twoNuCompareLineWidths = drawable.map(function (series) {
      return series.index === activeIndex ? "3.6" : "1.6";
    }).join(",");
    canvas.dataset.twoNuCompareSeriesOpacity = drawable.map(function (series) {
      return "1";
    }).join(",");
    canvas.dataset.twoNuCompareFillOpacity = drawable.map(function (series) {
      return ".035";
    }).join(",");
  };

  ComparisonController.prototype.drawCardRadars = function () {
    if (!this.root) return;
    var controller = this;
    var drawable = this.items.map(function (item, index) {
      return { item: item, index: index };
    }).filter(function (series) {
      return controller.seriesHasScores(series.item);
    });
    this.root.querySelectorAll("[data-two-nu-compare-card-canvas]").forEach(function (canvas) {
      var holder = canvas.closest("[data-two-nu-compare-card-radar]");
      var activeIndex = Number(canvas.dataset.twoNuCompareRadarIndex);
      var available = drawable.length > 0;
      if (holder) holder.hidden = !available;
      if (!available) return;
      controller.drawRadarCanvas(canvas, drawable, activeIndex, false);
    });
  };

  ComparisonController.prototype.drawSharedRadar = function () {
    var canvas = this.elements.canvas;
    if (!canvas || !window.matchMedia("(max-width: 749px)").matches) return;
    var drawable = this.items.map(function (item, index) {
      return { item: item, index: index };
    }).filter(function (series) {
      return AXES.some(function (axis) {
        return numberOrNull(series.item.profile.activityScores[axis]) !== null;
      });
    });
    if (this.elements.notRated) this.elements.notRated.hidden = drawable.length > 0;
    canvas.hidden = drawable.length === 0;
    if (!drawable.length) return;
    this.drawRadarCanvas(canvas, drawable, this.activeIndex, false);
  };

  ComparisonController.prototype.drawRadars = function () {
    if (!this.dialogIsOpen()) return;
    this.drawCardRadars();
  };

  ComparisonController.prototype.drawRadar = function () {
    this.drawRadars();
  };

  ComparisonController.prototype.marketSignature = function () {
    return cleanString(firstDefined(
      this.root && this.root.dataset.marketSignature,
      [
        this.root && this.root.dataset.country,
        this.root && this.root.dataset.currency,
        this.root && this.root.dataset.rootUrl
      ].filter(Boolean).join("|")
    ), 240);
  };

  ComparisonController.prototype.productUrl = function (handle) {
    var root = cleanString(firstDefined(
      this.root && this.root.dataset.rootUrl,
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root,
      "/"
    ), 240);
    if (root.charAt(root.length - 1) !== "/") root += "/";
    return root + "products/" + encodeURIComponent(handle) + ".js";
  };

  ComparisonController.prototype.fetchProduct = async function (handle, signal) {
    var cached = this.productCache.get(handle);
    if (cached && Date.now() - cached.time < PRODUCT_CACHE_MS) return cached.product;
    var response = await fetch(this.productUrl(handle), {
      method: "GET",
      headers: { Accept: "application/json" },
      signal: signal,
      credentials: "same-origin"
    });
    if (!response.ok) {
      var error = new Error("Product refresh failed");
      error.status = response.status;
      throw error;
    }
    var product = await response.json();
    this.productCache.set(handle, { time: Date.now(), product: product });
    return product;
  };

  ComparisonController.prototype.refresh = async function () {
    if (!this.items.length) return { status: "empty" };
    if (this.refreshController) this.refreshController.abort();
    var refreshRequest = new AbortController();
    this.refreshController = refreshRequest;
    var signal = refreshRequest.signal;
    var controller = this;
    var grouped = new Map();
    this.items.forEach(function (item) {
      if (!item.productHandle) return;
      if (!grouped.has(item.productHandle)) grouped.set(item.productHandle, []);
      grouped.get(item.productHandle).push(item.variantId);
    });
    var fresh = [];
    var soldOut = [];
    var unresolved = [];
    var failed = [];
    var affected = new Set();
    var requests = Array.from(grouped.keys()).map(async function (handle) {
      try {
        return { handle: handle, product: await controller.fetchProduct(handle, signal) };
      } catch (error) {
        return { handle: handle, error: error };
      }
    });
    var results = await Promise.all(requests);
    if (signal.aborted || this.refreshController !== refreshRequest) return { status: "aborted" };
    results.forEach(function (result) {
      var variantIds = grouped.get(result.handle) || [];
      if (result.error || !result.product || !Array.isArray(result.product.variants)) {
        if (!(result.error && result.error.name === "AbortError")) {
          failed.push.apply(failed, variantIds);
        }
        return;
      }
      variantIds.forEach(function (variantId) {
        var item = controller.items.find(function (entry) {
          return entry.variantId === variantId && entry.productHandle === result.handle;
        });
        if (!item) return;
        var variant = result.product.variants.find(function (entry) {
          return String(entry.id) === variantId;
        });
        if (!variant) {
          controller.runtimeStatus.set(variantId, "unresolved");
          unresolved.push(variantId);
          affected.add(variantId);
          return;
        }
        var price = numberOrNull(variant.price);
        if (price === null || typeof variant.available !== "boolean") {
          failed.push(variantId);
          return;
        }
        item.sku = cleanString(firstDefined(variant.sku, item.sku), 160);
        item.commerce.price = price;
        item.commerce.compareAtPrice = numberOrNull(variant.compare_at_price);
        item.commerce.currency = controller.currentCurrency(item);
        item.commerce.available = variant.available;
        item.commerce.capturedAt = nowIso();
        item.commerce.marketSignature = controller.marketSignature();
        item.commerce.source = "product-api";
        controller.runtimeStatus.set(variantId, variant.available ? "fresh" : "sold-out");
        var catalogItem = clone(controller.catalog.get(variantId) || item);
        catalogItem.sku = item.sku;
        catalogItem.commerce = clone(item.commerce);
        controller.catalog.set(variantId, catalogItem);
        affected.add(variantId);
        if (variant.available) fresh.push(variantId);
        else soldOut.push(variantId);
      });
    });
    this.persist(false);
    this.items.forEach(function (item) {
      if (affected.has(item.variantId)) controller.updateCommerceCard(item);
    });
    if (this.refreshController === refreshRequest) this.refreshController = null;
    this.emit("two-nu:compare-hydrated", {
      fresh: fresh,
      soldOut: soldOut,
      unresolved: unresolved,
      failed: failed
    });
    return {
      status: failed.length || unresolved.length ? "partial" : "hydrated",
      fresh: fresh,
      soldOut: soldOut,
      unresolved: unresolved,
      failed: failed
    };
  };

  ComparisonController.prototype.isPrescription = function (item) {
    return item.profile.prescription.isPrescription === true ||
      item.profile.features.prescription === true ||
      item.selection.lensFamilyKey === "pre" ||
      item.selection.lensFamilyKey === "hex_pre";
  };

  ComparisonController.prototype.addExactVariantToCart = async function (variantId, button) {
    var controller = this;
    var id = cleanId(variantId);
    var item = this.items.find(function (entry) { return entry.variantId === id; });
    if (!item) return;
    if (this.pendingCartIds.has(id)) return;
    var state = this.purchaseState(item);
    if (state !== "ready") {
      this.announce(this.availabilityLabel(item));
      return;
    }
    if (this.isPrescription(item)) {
      var prescriptionUrl = this.variantUrl(item);
      if (prescriptionUrl) window.location.assign(prescriptionUrl);
      return;
    }
    var root = cleanString(firstDefined(
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root,
      this.root && this.root.dataset.rootUrl,
      "/"
    ), 240);
    if (root.charAt(root.length - 1) !== "/") root += "/";
    var cartAddUrl = window.routes && window.routes.cart_add_url
      ? window.routes.cart_add_url
      : root + "cart/add.js";
    try {
      var parsedCartAddUrl = new URL(cartAddUrl, window.location.origin);
      if (!/\.js$/.test(parsedCartAddUrl.pathname)) parsedCartAddUrl.pathname += ".js";
      cartAddUrl = parsedCartAddUrl.origin === window.location.origin
        ? parsedCartAddUrl.pathname + parsedCartAddUrl.search
        : parsedCartAddUrl.href;
    } catch (error) {
      if (!/\.js(?:\?|$)/.test(cartAddUrl)) cartAddUrl += ".js";
    }
    var originalLabel = button.textContent;
    var succeeded = false;
    var becameUnavailable = false;
    this.pendingCartIds.add(id);
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    button.textContent = this.label("addingToCart");
    try {
      var response = await fetch(cartAddUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          items: [{
            id: Number(id),
            quantity: 1,
            properties: {
              _url: this.variantUrl(item) || window.location.pathname,
              _page_of_purchase: window.location.pathname,
              _isAddon: false
            }
          }]
        })
      });
      if (!response.ok) {
        var responseText = await response.text();
        var responsePayload = safeParse(responseText, null);
        var responseMessage = cleanString(firstDefined(
          responsePayload && responsePayload.description,
          responsePayload && responsePayload.message,
          responsePayload && responsePayload.errors,
          responseText
        ), 1200).toLowerCase();
        var cartError = new Error("Cart add failed");
        cartError.status = response.status;
        cartError.unavailable = response.status === 422 && /sold[\s-]*out|out[\s-]*of[\s-]*stock|not\s+available|unavailable/.test(responseMessage);
        throw cartError;
      }
      await response.json();
      succeeded = true;
      button.textContent = this.label("addedToCartShort");
      this.announce(this.label("cartAdded"));
      this.emit("two-nu:compare-cart", {
        action: "add",
        variantId: id,
        source: "comparison"
      });
      this.close("cart", { suppressFocusRestore: true });
      this.updateCartBadges(root);
      window.setTimeout(function () {
        if (typeof window.twoNuOpenDockCart === "function") {
          window.twoNuOpenDockCart(button);
        } else {
          controller.showToast(controller.label("cartAdded"), false, false);
        }
      }, 60);
    } catch (error) {
      if (error && error.unavailable === true) {
        this.pendingCartIds.delete(id);
        item.commerce.available = false;
        this.runtimeStatus.set(id, "sold-out");
        this.persist(false);
        this.render();
        becameUnavailable = true;
      }
      if (!becameUnavailable && button.isConnected) {
        button.textContent = this.label("cartError");
        button.classList.add("is-error");
      }
      this.announce(becameUnavailable ? this.label("soldOut") : this.label("cartError"));
      this.emit("two-nu:compare-error", {
        action: "cart",
        code: becameUnavailable ? "UNAVAILABLE" : "CART_FAILED",
        variantId: id
      });
    } finally {
      this.pendingCartIds.delete(id);
      if (button.isConnected) {
        button.removeAttribute("aria-busy");
        if (succeeded) {
          window.setTimeout(function () {
            if (!button.isConnected) return;
            button.textContent = originalLabel;
            button.disabled = !controller.canUsePurchase(item);
          }, 1800);
        } else if (!becameUnavailable && this.runtimeStatus.get(id) !== "sold-out") {
          window.setTimeout(function () {
            if (!button.isConnected) return;
            button.textContent = originalLabel;
            button.classList.remove("is-error");
            button.disabled = !controller.canUsePurchase(item);
          }, 2200);
        }
      }
    }
  };

  ComparisonController.prototype.updateCartBadges = async function (root) {
    try {
      var response = await fetch(root + "cart.js", {
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      });
      if (!response.ok) return;
      var cart = await response.json();
      document.querySelectorAll("[data-two-nu-dock-cart-count]").forEach(function (badge) {
        badge.textContent = cart.item_count ? String(cart.item_count) : "";
        badge.classList.toggle("is-empty", !cart.item_count);
        badge.setAttribute("aria-hidden", cart.item_count ? "false" : "true");
      });
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
      return cart;
    } catch (error) {
      // Cart already accepted the item; badge refresh failure is non-blocking.
      return null;
    }
  };

  ComparisonController.prototype.restoreAiTryOnNode = function (node, anchor, originalParent, originalNext) {
    if (!node) return;
    if (anchor && anchor.parentNode && anchor.parentNode.isConnected) {
      anchor.parentNode.insertBefore(node, anchor);
    } else if (originalParent && originalParent.isConnected) {
      if (originalNext && originalNext.parentNode === originalParent) originalParent.insertBefore(node, originalNext);
      else originalParent.appendChild(node);
    } else {
      (document.body || document.documentElement).appendChild(node);
    }
    if (anchor && anchor.parentNode) anchor.remove();
  };

  ComparisonController.prototype.cleanupAiTryOnLayer = function (restoreFocus) {
    var layer = this.aiTryOnLayer;
    if (!layer) return;
    this.aiTryOnLayer = null;
    window.clearTimeout(layer.openTimer);
    if (layer.observer) layer.observer.disconnect();
    if (layer.host && layer.host.hasAttribute("open")) {
      if (typeof layer.host.close === "function") layer.host.close();
      else layer.host.removeAttribute("open");
    }
    Object.keys(layer.masterAttributes || {}).forEach(function (attribute) {
      var value = layer.masterAttributes[attribute];
      if (value === null) layer.master.removeAttribute(attribute);
      else layer.master.setAttribute(attribute, value);
    });
    if (layer.master) layer.master.classList.remove("two-nu-compare__ai-master--hosted");
    this.restoreAiTryOnNode(layer.root, layer.rootAnchor, layer.rootParent, layer.rootNext);
    this.restoreAiTryOnNode(layer.master, layer.masterAnchor, layer.masterParent, layer.masterNext);
    if (restoreFocus && layer.trigger && layer.trigger.isConnected && this.dialogIsOpen()) {
      try {
        layer.trigger.focus({ preventScroll: true });
      } catch (error) {
        layer.trigger.focus();
      }
    }
    this.aiTryOnTrigger = null;
  };

  ComparisonController.prototype.openAiTryOnLayer = function (item, root, master, trigger) {
    var host = this.elements.aiHost;
    if (!host || !root || !master || this.aiTryOnLayer) return false;

    var masterAttributeNames = [
      "data-product-id",
      "data-variant-id",
      "data-variant-image",
      "data-variant-title",
      "data-variant-label",
      "data-product-handle"
    ];
    var masterAttributes = {};
    masterAttributeNames.forEach(function (attribute) {
      masterAttributes[attribute] = master.hasAttribute(attribute) ? master.getAttribute(attribute) : null;
    });
    var rootParent = root.parentNode;
    var rootNext = root.nextSibling;
    var masterParent = master.parentNode;
    var masterNext = master.nextSibling;
    var rootAnchor = document.createComment("two-nu-ai-tryon-root");
    var masterAnchor = document.createComment("two-nu-ai-tryon-master");
    root.parentNode.insertBefore(rootAnchor, root);
    master.parentNode.insertBefore(masterAnchor, master);
    host.replaceChildren(root, master);
    master.classList.add("two-nu-compare__ai-master--hosted");

    var controller = this;
    var layer = {
      host: host,
      root: root,
      master: master,
      rootAnchor: rootAnchor,
      masterAnchor: masterAnchor,
      rootParent: rootParent,
      rootNext: rootNext,
      masterParent: masterParent,
      masterNext: masterNext,
      masterAttributes: masterAttributes,
      trigger: trigger,
      observer: null,
      openTimer: 0,
      appSeen: false
    };
    this.aiTryOnLayer = layer;
    this.aiTryOnTrigger = trigger;
    layer.observer = new MutationObserver(function () {
      var appModal = root.querySelector(".ai-tryon-modal");
      if (appModal) {
        layer.appSeen = true;
        return;
      }
      if (layer.appSeen) controller.cleanupAiTryOnLayer(true);
    });
    layer.observer.observe(root, { childList: true, subtree: true, attributes: true });

    if (!host.hasAttribute("open")) {
      if (typeof host.showModal === "function") host.showModal();
      else {
        host.setAttribute("open", "");
        host.setAttribute("aria-modal", "true");
      }
    }

    var variantLabel = this.variantLabel(item);
    master.dataset.productId = item.productId || "";
    master.dataset.variantId = item.variantId;
    master.dataset.variantImage = item.image.url || "";
    master.dataset.variantTitle = variantLabel
      ? item.productTitle + " (" + variantLabel + ")"
      : item.productTitle;
    master.dataset.variantLabel = variantLabel;
    master.dataset.productHandle = item.productHandle || "";

    layer.openTimer = window.setTimeout(function () {
      if (!controller.aiTryOnLayer || controller.aiTryOnLayer !== layer || layer.appSeen) return;
      controller.cleanupAiTryOnLayer(true);
      var fallback = item.profile.aiTryOn.url || controller.variantUrl(item);
      if (fallback) window.location.assign(fallback);
    }, 7000);
    window.requestAnimationFrame(function () {
      if (controller.aiTryOnLayer === layer) master.click();
    });
    return true;
  };

  ComparisonController.prototype.handoffAiTryOn = function (variantId, sourceButton) {
    var id = cleanId(variantId);
    var item = this.items.find(function (entry) { return entry.variantId === id; });
    if (!item || this.aiTryOnLayer) return;
    var request = this.emit("two-nu:ai-tryon-request", {
      variantId: id,
      item: clone(item),
      source: "comparison"
    }, true);
    if (request.defaultPrevented) return;
    this.bindRoot();
    var controller = this;
    var trigger = sourceButton instanceof HTMLElement ? sourceButton : document.activeElement;
    var startedAt = Date.now();
    window.clearTimeout(this.aiTryOnRootTimer);
    function launchWhenReady() {
      controller.bindRoot();
      var root = document.getElementById("ai-tryon-react-root");
      var master = controller.ensureAiTryOnMaster();
      if (root && root.parentNode && master && master.parentNode && controller.elements.aiHost) {
        controller.aiTryOnRootTimer = 0;
        controller.openAiTryOnLayer(item, root, master, trigger);
        return;
      }
      if (Date.now() - startedAt < 2500) {
        controller.aiTryOnRootTimer = window.setTimeout(launchWhenReady, 80);
        return;
      }
      controller.aiTryOnRootTimer = 0;
      var fallback = item.profile.aiTryOn.url || controller.variantUrl(item);
      if (fallback) window.location.assign(fallback);
    }
    launchWhenReady();
  };

  ComparisonController.prototype.showToast = function (message, allowUndo, allowView) {
    if (!this.elements.toast || !this.elements.toastMessage) return;
    this.placeFeedback();
    this.elements.toast.setAttribute("aria-label", message);
    window.clearTimeout(this.toastTimer);
    this.elements.toastMessage.textContent = message;
    if (this.elements.toastUndo) this.elements.toastUndo.hidden = !allowUndo;
    if (this.elements.toastView) this.elements.toastView.hidden = !allowView;
    this.elements.toast.hidden = false;
    this.elements.toast.classList.add("is-visible");
    var controller = this;
    this.toastTimer = window.setTimeout(function () {
      controller.hideToast();
    }, 6000);
  };

  ComparisonController.prototype.hideToast = function () {
    window.clearTimeout(this.toastTimer);
    if (!this.elements.toast) return;
    this.elements.toast.classList.remove("is-visible");
    this.elements.toast.hidden = true;
  };

  ComparisonController.prototype.announce = function (message) {
    if (!this.elements.live) return;
    this.placeFeedback();
    var live = this.elements.live;
    live.textContent = "";
    window.setTimeout(function () {
      live.textContent = message;
    }, 20);
  };

  window.TwoNuCompare = new ComparisonController();
}());
